
window['langArr'] = [];

langArr['en'] = {
    'odds': 'ODDS',
    'popular': 'Popular',
    'standings': 'Standings',
    'final_score': 'Final Score',
    'home_goals': 'Home Goals',
    'away_goals': 'Away Goals',
    'score': 'Score',
    'last_results': 'Last Results',
    'live_score': 'Live Score',
    'teams': 'Teams',
    'team': 'TEAM',
    'pts': 'PTS',
    'pos': 'POS',
    'please_login': 'Please_login',
    'minimum_stake_is': 'Minimum stake is',
    'maximum_stake_is': 'Maximum stake is',
    'you_dont_have_enough_deposit': 'You don’t have enough deposit',
    'unknown_session_id': 'Unknown SessionID',
    'please_login': 'Please log in in order to place a bet!',
    'betting': 'Betting',
    'statistics': 'Statistics',
    'tickets': 'Tickets',
    'amount': 'Amount',
    'no_of_rounds': 'No. Of Rounds',
    'repeat_last': 'Repeat Last',
    'random_six': 'Random Six',
    'random': 'Random',
    'random_one': 'Random',
    'all_colors': 'All Colors',
    'hot_six': 'Hot Six',
    'cold_six': 'Cold Six',
    'buy_ticket': 'Buy Ticket',
    'chosen_ticket_combination': 'Chosen Ticket Combination',
    'all_of_the_balls': 'All Of The Balls',
    'more_odd': 'More odd',
    'more_even': 'More even',
    'less': 'Less',
    'more': 'More',
    'even': 'Even',
    'odd': 'Odd',
    'first_five_balls': 'First 5 Balls',
    'first_ball': 'First Ball',
    'last_ball': 'Last Ball',
    'top_color': 'Top Color',
    'red': 'Red',
    'green': 'Green',
    'blue': 'blue',
    'purple': 'Purple',
    'brown': 'Brown',
    'yellow': 'Yellow',
    'orange': 'Orange',
    'black': 'Black',
    'silver': 'Black',
    'the_most_common_numbers': 'The most common numbers',
    'the_rarest_numbers': 'The rearest numbers',
    'ticket_id': 'Ticket ID',
    'all': 'All',
    'common_color': 'Common Color',
    'parity': 'Parity',
    'round_no': 'Round No',
    'jackpot_code': 'Jackpot Code',
    'purchased_a_ticket': 'You have successfully purchased a ticket',
    'chose_some_bets': 'Please choose some bets to buy ticket',
    'winner': 'Winner',
    'w': 'W',
    'l': 'L',
    'FORM': 'FORM',
    'place': 'Place',
    'show': 'Show',
    'second': 'Second',
    'third': 'Third',
    'trifecta': 'Trifecta',
    'perfecta': 'Perfecta',
    'double_chance': 'Double Chance',
    'low': 'Low',
    'high': 'High',
    'sum': 'Sum',
    'jackpot': 'JACKPOT',
    'race': 'RACE',
    'mega_jackpot': 'Mega Jackpot',
    'regional_jackpot': 'Regional Jackpot',
    'weldmag_regional_jackpot': 'SUPERBONUS',
    'weldmag_jackpot':'WELDPOT',
    'number_of_goals': 'NUMBER OF GOALS',
    'result': 'RESULT',
    'total_goals': 'TOTAL GOALS',
    'correct_score': 'CORRECT SCORE',
    'ht': 'HT',
    'ft': 'FT',
    'ht_ft': 'HT/FT',
    'next': 'NEXT',
    'half_time_full_time': 'HALF TIME / FULL TIME',
    'over_under': 'OVER UNDER',
    'full_time_goals_combination': 'FULL TIME / GOALS COMBINATION',
    'gg_ng': 'GG / NG',
    'double_chance_gg_ng': 'DOUBLE CHANCE + GG / NG',
    'home': 'HOME',
    'away': 'AWAY',
    'general_statistics': 'General Statistics',
    'odd_even': 'ODD/EVEN',
    'odd_even_home': 'ODD / EVEN HOME',
    'odd_even_away': 'ODD / EVEN AWAY',
    'home_score': 'HOME SCORE',
    'away_score': 'AWAY SCORE',
    'home_ou': 'HOME OU',
    'away_ou': 'AWAY OU',
    'uo15_1x2': 'UO15 + 1X2',
    'uo25_1x2': 'UO25 + 1X2',
    'gg_ng_over_under': 'GG / NG OVER UNDER',
    'first_half': 'FIRST HALF',
    'slip': 'Slip',
    'bet_slip': 'BET SLIP',
    'combinations': 'Combinations',
    'system': 'System',
    'total_odd': 'Total Odd',
    'total_stake': 'Total Stake',
    'potential_maximal_win': 'Potential Maximal Win',
    'place_bet': 'Place bets',
    'favorites': 'Favorites',
    'underdogs': 'Underdogs',
    'please_choose': 'Please choose some bets first',
    'open': 'OPEN',
    'chose_valid_amount': 'Please select valid betting amount',
    'no_tickets_for_current_game': 'There are no tickets for current game',
    'game': 'Game',
    'apple_video_no_support': 'Your apple device is not supporting video streaming, please upgrade to iOS 10+ to watch race videos.',
    'color': 'Color',
    'error_purchasing_ticket': 'Error purchasing ticket',
    'choose_1_2_4_common': 'Please choose 1,2 or 4 colors for most common color',
    'choose_1_2_4_first': 'Please choose 1,2 or 4 colors for the first ball',
    'choose_1_2_4_last': 'Please choose 1,2 or 4 colors for the last ball',
    'confirm_buying': 'OK',
    'cancel_buying': 'Cancel',
    'buying_title': 'Are you sure you want to buy the ticket?',
    'please_wait': 'Please wait...',
    'tutorial_close': 'CLOSE',
    'tutorial_next': 'NEXT',
    'tutorial_back': 'BACK',
    'tutorial_1': 'This quick tutorial will explain to you how to make a bet on "Lucky Balls"',
    'tutorial_2': 'Here you can choose your numbers. Choose 6 to 10 numbers.',
    'tutorial_3': 'You can choose bets like even/odd, top color etc. clicking on buttons and/or colors of a bets.',
    'tutorial_4': 'Choose amount of a bet: minimal, maximal, three presented values or enter custom amount.',
    'tutorial_5': 'Choose a number of game rounds.',
    'tutorial_6': 'By clicking on "Buy ticket" your bet will be accepted.',
    'tutorial_7': 'In this part of a screen you can monitor your tickets during the round. Drawn numbers and winning bets will be marked on ticket with different colors. Header of a winning tickets will be marked green.',
    'tutorial_8': 'You can watch drawing of a balls in this part of screen.',
    'tutorial_9': 'Various statistics can help you to make your winning combination.',
    'help': 'Help',
    'tickets-vfl': 'Tikets/Stats',
    'results': 'RESULTS',
    'for_draw': 'For Draw',
    'draw': 'Draw',
    'd': 'D',
    'results_lower': 'Results',
    'round_completed': 'ROUND COMPLETED',
    'first_5_no_award': 'FIRST 5 BALLS WITHOUT AWARD',
    'last_bets': 'Last bets please!',
    'color_betting': 'Color Betting',
    'preballs_sum': 'Preballs sum',
    'bonus_numbers': 'Bonus numbers',
    'current_round': 'Current round',
    'rounds_total': 'rounds total',
    'value': 'Value',
    'quick_lucky_ball': 'Quick Lucky Ball',
    'Login': 'Login',
    'Logout': 'Logout',
    'login_credentials': 'Login credentials',
    'Username': 'Username',
    'Password': 'Password',
    'request_payout': 'Request payout',
    'payout_pin': 'Payout PIN',
    'Ok': 'Ok',
    'auth_failed': 'Error: Authentication failed',
    'enter_alias': 'Enter alias',
    'Submit': 'Submit',
    'Chat': 'Chat',
    'win_multiplier': 'WIN MULTIPLIER',
    'win_amount': 'WIN AMOUNT',
    'first_color': 'FIRST COLOR',
    'sure2share': 'Are you sure u want to share?',
    'Share': 'Share',
    'chat_message': 'Chat Message',
    'yes': 'Yes',
    'no': 'No',
    'welcome': 'Welcome',
    'credit_balance': 'Credit balance : ',
    'last_color': 'Last Color',
    'last_ball_parity': 'Last Ball Parity',
    'ticket_amount_less': 'Ticket amount cannot be less than ',
    'ticket_amount_more': 'Ticket amount cannot be more than ',
    'betting_info': 'Available from 7 - 23 h'
};

langArr['rs'] = {
    'odds': 'Kvоте',
    'popular': 'Popularno',
    'standings': 'Tabela',
    'final_score': 'Konačan Ishod',
    'home_goals': 'Domaćin Golovi',
    'away_goals': 'Gost Golovi',
    'score': 'Daje Gol',
    'last_results': 'Poslednji rezultati',
    'live_score': 'Uživo',
    'teams': 'Timovi',
    'team': 'TIM',
    'pts': 'BOD',
    'please_login': 'Molimo Vas da se ulogujete',
    'minimum_stake_is': 'Minimalan ulog je',
    'maximum_stake_is': 'Maksimalan ulog je',
    'you_dont_have_enough_deposit': 'Nemate dovoljno depozita',
    'unknown_session_id': 'Nepoznat SessionID',
    'please_login': 'Molimo Vas da se ulogujete da bi ste uplatili tiket!',
    'betting': 'Klađenje',
    'statistics': 'Statistika',
    'tickets': 'Tiketi',
    'amount': 'Iznos',
    'no_of_rounds': 'Br. Izvlačenja',
    'repeat_last': 'Ponovi Opkladu',
    'random_six': 'Nasumičnih 6',
    'random': 'Slučajni',
    'random_one': 'Slučajni',
    'all_colors': 'Sve Boje',
    'hot_six': 'Najčešćih 6',
    'cold_six': 'Najređih 6',
    'buy_ticket': 'Uplati Tiket',
    'chosen_ticket_combination': 'Odabrana Kombinacija',
    'all_of_the_balls': 'Sve Loptice',
    'more_odd': 'Više Neparnih',
    'more_even': 'Više Parnih',
    'less': 'Manje',
    'more': 'Više',
    'even': 'Par',
    'odd': 'Nep',
    'first_five_balls': 'Prvih 5',
    'first_ball': 'Prva Loptica',
    'last_ball': 'Poslednja Loptica',
    'top_color': 'Najčešća Boja',
    'red': 'Crvena',
    'green': 'Zelena',
    'blue': 'Plava',
    'purple': 'Ljubičasta',
    'brown': 'Braon',
    'yellow': 'Žuta',
    'orange': 'Narandžasta',
    'black': 'Crna',
    'silver': 'Crna',
    'the_most_common_numbers': 'Najčešći brojevi',
    'the_rarest_numbers': 'Najređi brojevi',
    'ticket_id': 'Broj Tiketa',
    'all': 'Sve Loptice',
    'common_color': 'Najčešća Boja',
    'parity': 'Par/Nepar',
    'round_no': 'Igra Br.',
    'jackpot_code': 'Jackpot Kod',
    'purchased_a_ticket': 'Uspešno ste uplatili tiket!',
    'chose_some_bets': 'Odaberite opkladu da bi uplatili tiket!',
    'winner': 'Pobednik',
    'w': 'P',
    'l': 'I',
    'FORM': 'PROŠ',
    'place': 'U prva dva',
    'show': 'U prva tri',
    'second': 'Drugo Mesto',
    'third': 'Treće mesto',
    'trifecta': 'Trifekta',
    'perfecta': 'Perfekta',
    'double_chance': 'Dupla Šansa',
    'low': 'Manje',
    'high': 'Više',
    'sum': 'Suma',
    'jackpot': 'JACKPOT',
    'race': 'TRKA',
    'mega_jackpot': 'Mega Jackpot',
    'regional_jackpot': 'Regionalni Jackpot',
    'weldmag_regional_jackpot': 'SUPERBONUS',
    'weldmag_jackpot':'WELDPOT',
    'number_of_goals': 'BROJ GOLOVA',
    'result': 'REZULTAT',
    'total_goals': 'UKUPNO GOLOVA',
    'correct_score': 'TAČAN REZULTAT',
    'ht': 'PO',
    'ft': 'KR',
    'ht_ft': 'POLUVREME-KRAJ',
    'next': 'SLEDEĆA',
    'half_time_full_time': 'POLUVREME-KRAJ',
    'over_under': 'GOLOVI',
    'full_time_goals_combination': 'KONAČAN ISHOD / GOLOVI',
    'gg_ng': 'GG / NG',
    'double_chance_gg_ng': 'DUPLA ŠANSA+ GG / NG',
    'home': 'DOMAĆIN',
    'away': 'GOST',
    'general_statistics': 'Generalna Statistika',
    'odd_even': 'NEP/PAR',
    'odd_even_home': 'NEPARAN/PARAN DOMAĆIN',
    'odd_even_away': 'NEPARAN/PARAN GOST',
    'home_score': 'GOLOVA DOMAĆIN',
    'away_score': 'GOLOVA GOST',
    'home_ou': 'DOMAĆIN GOLOVI',
    'away_ou': 'GOST GOLOVI',
    'uo15_1x2': 'UO15 + 1X2',
    'uo25_1x2': 'UO25 + 1X2',
    'gg_ng_over_under': 'GG / NG GOLOVI',
    'first_half': 'PRVO POLUVREME',
    'slip': 'Tiket',
    'bet_slip': 'Tiket',
    'combinations': 'Kombinacija',
    'system': 'Sistem',
    'total_odd': 'Ukupna Kvota',
    'total_stake': 'Iznos Uplate',
    'potential_maximal_win': 'Eventualni Dobitak',
    'place_bet': 'Uplati Tiket',
    'favorites': 'Favoriti',
    'underdogs': 'Outsajderi',
    'please_choose': 'Odaberite opkladu da bi uplatili tiket!',
    'open': 'OTVOREN',
    'chose_valid_amount': 'Izaberite ispravnu cifru opklade',
    'no_tickets_for_current_game': 'Nema tiketa za igru u toku',
    'game': 'Igra',
    'apple_video_no_support': 'Vaš apple uredjaj ne podržava strimovanje videa, upgadujte software na iOS10+ da bi mogli da gledate video snimke.',
    'color': 'Boja',
    'error_purchasing_ticket': 'Greška prilikom kupovine tiketa.',
    'choose_1_2_4_common': 'Odaberite jednu, dve ili četiri boje za najčešću boju',
    'choose_1_2_4_first': 'Odaberite jednu, dve ili četiri boje za prvu lopticu',
    'choose_1_2_4_last': 'Odaberite jednu, dve ili četiri boje za poslednju lopticu',
    'confirm_buying': 'Potvrdi',
    'cancel_buying': 'Odustani',
    'buying_title': 'Da li ste sigurni da želite da uplatite tiket?',
    'please_wait': 'Molimo sačekajte...',
    'tutorial_close': 'ZATVORI',
    'tutorial_next': 'SLEDEĆI',
    'tutorial_back': 'NAZAD',
    'tutorial_1': 'Ovo kratko uputstvo će vam pokazati kako da unesete opkladu na igri "Lucky Balls"',
    'tutorial_2': 'Ovde birate vaše brojeve. Odaberite 6 do 10 brojeva.',
    'tutorial_3': 'Opklade na spoljne uloge( par/nepar, najčešća boja itd.) birate klikom na dugmiće i/ili boje spoljne opklade.',
    'tutorial_4': 'Odaberite iznos uplate: minimalni, maksimalni, tri predefinisane vrednosti ili unestite sami željeni iznos uplate.',
    'tutorial_5': 'Odaberite broj kola za igru unapred.',
    'tutorial_6': 'Klikom na "Uplati tiket" vaša opklada će biti unešena u sistem.',
    'tutorial_7': 'U ovom delu možete da pratite status vašeg tiketa tokom izvlačenja. Izvučeni brojevi i dobitne spoljne opklade će biti posebno označeni drugom bojom. Zaglavlje dobitnih\ tiketa je označeno zelenom bojom.',
    'tutorial_8': 'Izvlačenje kuglica možete da pratite na ovom delu ekrana, isto kao i da se nalazite u sportskoj kladionici.',
    'tutorial_9': 'Razne statistike vam mogu pomoći da uplatite vašu dobitnu kombinaciju.',
    'help': 'Pomoć',
    'tickets-vfl': 'Tiket/Stat.',
    'results': 'REZULTATI',
    'for_draw': 'Za Izvlačenje',
    'draw': 'Nerešeno',
    'd': 'N',
    'results_lower': 'Rezultati',
    'round_completed': '     IGRA JE ZAVRŠENA',
    'first_5_no_award': '               PRVIH 5 LOPTICA',
    'last_bets': 'Poslednji ulozi!',
    'color_betting': 'Klađenje na boje',
    'preballs_sum': 'Prvih 5',
    'bonus_numbers': 'Bonus brojevi',
    'current_round': 'Trenutno izvlačenje',
    'rounds_total': 'ukupno izvlačenja',
    'value': 'Broj',
    'quick_lucky_ball': 'Brzih 6',
    'Login': 'Uloguj se',
    'Logout': 'Izloguj se',
    'login_credentials': 'Kredencijali za logovanje',
    'Username': 'Korisničko ime',
    'Password': 'Password',
    'request_payout': 'Zahtev za isplatu',
    'payout_pin': 'PIN za isplatu',
    'Ok': 'Ok',
    'auth_failed': 'Greška: Neuspešna autentifikacija',
    'enter_alias': 'Unesi Alias',
    'Submit': 'Podnesi',
    'Chat': 'Čet',
    'win_multiplier': 'DOBITNI MULTIPLIKATOR',
    'win_amount': 'DOBITNI IZNOS',
    'first_color': 'PRVA BOJA',
    'sure2share': 'Jeste li sigurni da želite da podelite?',
    'Share': 'Podeliti',
    'chat_message': 'Čet poruka',
    'yes': 'Da',
    'no': 'Ne',
    'welcome': 'Dobrodošli',
    'credit_balance': 'Kreditno stanje:',
    'last_color': 'Poslednja Boja',
    'last_ball_parity': 'Poslednja Loptica Par/Nep',
    'ticket_amount_less': 'Iznos tiketa ne može biti manji od ',
    'ticket_amount_more': 'Iznos tiketa ne može biti veći od ',
    'betting_info': 'Dostupno od 7 - 23 h'
};

langArr['hr'] = {
    'odds': 'Kvоте',
    'popular': 'Populrno',
    'standings': 'Poredak',
    'final_score': 'Konačan Ishod',
    'home_goals': 'Domaćin Golovi',
    'away_goals': 'Gost Golovi',
    'score': 'Daje Gol',
    'last_results': 'Posljednji rezultati',
    'live_score': 'Uživo',
    'teams': 'Timovi',
    'team': 'Tim',
    'pts': 'BOD',
    'pos': 'POZ',
    'please_login': 'Molimo Vas da se ulogujete',
    'minimum_stake_is': 'Minimalan ulog je',
    'maximum_stake_is': 'Maksimalan ulog je',
    'you_dont_have_enough_deposit': 'Nemate dovoljno depozita',
    'unknown_session_id': 'Nevalidan SessionID',
    'please_login': 'Molimo Vas da se ulogujete da bi ste uplatili listić!',
    'betting': 'Igraj',
    'statistics': 'Statistika',
    'tickets': 'Listići',
    'amount': 'Iznos',
    'no_of_rounds': 'Br. izvlačenja',
    'repeat_last': 'Odigraj ponovno',
    'random_six': 'Nasumičnih 6',
    'random': 'Slučajni',
    'random_one': 'Slučajni',
    'all_colors': 'Sve boje',
    'hot_six': 'Najčešćih 6',
    'cold_six': 'Najrjeđih 6',
    'buy_ticket': 'IGRAJ',
    'chosen_ticket_combination': 'Odabrane kombinacije',
    'all_of_the_balls': 'Svi brojevi',
    'more_odd': 'Više neparnih',
    'more_even': 'Više parnih',
    'less': 'Manje',
    'more': 'Više',
    'even': 'Paran',
    'odd': 'Neparan',
    'first_five_balls': 'Zbroj prvih 5',
    'first_ball': 'Prvi broj',
    'last_ball': 'Posljednji broj',
    'top_color': 'Najčešća boja',
    'red': 'Crvena',
    'green': 'Zelena',
    'blue': 'Plava',
    'purple': 'Ljubičasta',
    'brown': 'Smeđa',
    'yellow': 'Žuta',
    'orange': 'Narančasta',
    'black': 'Crna',
    'silver': 'Crna',
    'the_most_common_numbers': 'Najčešći brojevi',
    'the_rarest_numbers': 'Najrjeđi brojevi',
    'ticket_id': 'Uplatni broj',
    'all': 'Sve kuglice',
    'common_color': 'Najčešća boja',
    'parity': 'Paran/Neparan',
    'round_no': 'Igra br.',
    'jackpot_code': 'Jackpot kod',
    'purchased_a_ticket': 'Listić je uplaćen.',
    'chose_some_bets': 'Odaberite okladu da bi uplatili listić!',
    'winner': 'Pobjednik',
    'w': 'P',
    'l': 'I',
    'FORM': 'PROŠ',
    'place': 'U prva dva',
    'show': 'U prva tri',
    'second': 'Drugo mjesto',
    'third': 'Treće mjesto',
    'trifecta': 'Trifekta',
    'perfecta': 'Perfekta',
    'double_chance': 'Dvostruka prilika',
    'low': 'Manje',
    'high': 'Više',
    'sum': 'Zbroj',
    'jackpot': 'JACKPOT',
    'race': 'TRKA',
    'mega_jackpot': 'Mega jackpot',
    'number_of_goals': 'BROJ GOLOVA',
    'result': 'REZULTAT',
    'total_goals': 'UKUPNO GOLOVA',
    'correct_score': 'TOČAN REZULTAT',
    'ht': 'PO',
    'ft': 'KR',
    'ht_ft': 'POLUVRIJEME-KRAJ',
    'next': 'SLJEDEĆA',
    'half_time_full_time': 'POLUVRIJEME-KRAJ',
    'over_under': 'GOLOVI',
    'full_time_goals_combination': 'KONAČAN ISHOD / GOLOVI',
    'gg_ng': 'GG / NG',
    'double_chance_gg_ng': 'DVOSTRUKA PRILIKA+ GG / NG',
    'home': 'DOMAĆIN',
    'away': 'GOST',
    'general_statistics': 'Općenita statistika',
    'odd_even': 'NEP/PAR',
    'odd_even_home': 'NEPARAN/PARAN DOMAĆIN',
    'odd_even_away': 'NEPARAN/PARAN GOST',
    'home_score': 'GOLOVA DOMAĆIN',
    'away_score': 'GOLOVA GOST',
    'home_ou': 'DOMAĆIN GOLOVI',
    'away_ou': 'GOST GOLOVI',
    'uo15_1x2': 'UO15 + 1X2',
    'uo25_1x2': 'UO25 + 1X2',
    'gg_ng_over_under': 'GG / NG GOLOVI',
    'first_half': 'PRVO POLUVRIJEME',
    'slip': 'Listić',
    'bet_slip': 'Listić',
    'combinations': 'Kombinacija',
    'system': 'Sistem',
    'total_odd': 'Ukupan koeficijent',
    'total_stake': 'Iznos uplate',
    'potential_maximal_win': 'Eventualni dobitak',
    'place_bet': 'Uplati listić',
    'favorites': 'Favoriti',
    'underdogs': 'Outsajderi',
    'please_choose': 'Odaberite okladu da bi uplatili listić!',
    'open': 'OTVOREN',
    'chose_valid_amount': 'Odaberite ispravan iznos oklade',
    'no_tickets_for_current_game': 'Nema listića za igru u tijeku',
    'game': 'Igra',
    'apple_video_no_support': 'Vaš apple uređaj ne podržava video prikaz, nadogradite software na iOS10+ kako biste mogli gledati video.',
    'color': 'Boja',
    'error_purchasing_ticket': 'Greška prilikom kupnje listića.',
    'choose_1_2_4_common': 'Odaberite jednu, dvije ili četiri boje za najčešće izvučenu boju',
    'choose_1_2_4_first': 'Odaberite jednu, dvije ili četiri boje za boju prve kuglice',
    'choose_1_2_4_last': 'Odaberite jednu, dvije ili četiri boje za boju posljednje kuglice',
    'confirm_buying': 'Potvrdi',
    'cancel_buying': 'Odustani',
    'buying_title': 'Jeste li sigurni da želite uplatiti listić?',
    'please_wait': 'Molimo pričekajte...',
    'tutorial_close': 'ZATVORI',
    'tutorial_next': 'SLIJEDEĆI',
    'tutorial_back': 'NAZAD',
    'tutorial_1': 'Ovo kratko uputstvo će vam pokazati kako da unesete okladu na igri "Lucky Balls"',
    'tutorial_2': 'Ovde birate vaše kuglice. Odaberite 6 do 10 kuglica.',
    'tutorial_3': 'Oklade na spoljne uloge( par/nepar, najčešća boja itd.) birate klikom na gumbe i/ili boje spoljne oklade.',
    'tutorial_4': 'Odaberite iznos uplate: minimalni, maksimalni, tri predefinirane vrijednosti ili unestite sami željeni iznos oklade.',
    'tutorial_5': 'Odaberite broj kola za igru unaprijed.',
    'tutorial_6': 'Klikom na "Uplati listić" vaša oklada će biti unešena u sistem.',
    'tutorial_7': 'U ovom dijelu možete pratiti status vašeg listića tokom izvlačenja. Izvučene kuglice i dobitne spoljne oklade će biti posebno označene drugom bojom. Zaglavlje dobitnih\ listića je označeno zelenom bojom.',
    'tutorial_8': 'Izvlačenje kuglica možete pratiti na ovom dijelu ekrana, isto kao i da se nalazite u sportskoj kladionici.',
    'tutorial_9': 'Razne statistike vam mogu pomoći da uplatite vašu dobitnu kombinaciju.',
    'help': 'Pomoć',
    'tickets-vfl': 'Tiket/Stat.',
    'results': 'REZULTATI',
    'for_draw': 'Za Izvlačenje',
    'draw': 'Nerešeno',
    'd': 'N',
    'results_lower': 'Rezultati',
    'round_completed': 'ROUND COMPLETED',
    'first_5_no_award': 'FIRST 5 BALLS WITHOUT AWARD',
    'last_bets': 'Last bets please!',
    'color_betting': 'Color Betting',
    'preballs_sum': 'Prvih 5',
    'bonus_numbers': 'Bonus numbers',
    'current_round': 'Trenutno izvlačenje',
    'rounds_total': 'ukupno izvlačenja',
    'value': 'Broj',
    'quick_lucky_ball': 'Brzih 6',
    'Login': 'Uloguj se',
    'Logout': 'Izloguj se',
    'login_credentials': 'Kredencijali za logovanje',
    'Username': 'Korisničko ime',
    'Password': 'Password',
    'request_payout': 'Zahtev za isplatu',
    'payout_pin': 'PIN za isplatu',
    'Ok': 'Ok',
    'auth_failed': 'Greška: Neuspešna autentifikacija',
    'enter_alias': 'Unesi Alias',
    'Submit': 'Podnesi',
    'Chat': 'Čet',
    'win_multiplier': 'DOBITNI MULTIPLIKATOR',
    'win_amount': 'DOBITNI IZNOS',
    'first_color': 'PRVA BOJA',
    'sure2share': 'Jeste li sigurni da želite da podelite?',
    'Share': 'Podeliti',
    'chat_message': 'Čet poruka',
    'yes': 'Da',
    'no': 'Ne',
    'welcome': 'Dobrodošli',
    'credit_balance': 'Stanje na računu ',
    'last_color': 'Poslednja Boja',
    'last_ball_parity': 'Posljednji broj Par/Nep',
    'ticket_amount_less': 'Iznos tiketa ne smije biti manji od ',
    'ticket_amount_more': 'Iznos tiketa ne smije biti veći od '
};

langArr['mk'] = {
    'odds': 'Квоти',
    'popular': 'ПОПУЛАРНО',
    'standings': 'ПЛАСМАН',
    'final_score': 'КОНЕЧЕН РЕЗУЛТАТ',
    'home_goals': 'ГОЛ ДОМАШНАТИ ТИМ',
    'away_goals': 'ГОЛ ГОСТИНСКОИТИ ТИМ',
    'score': 'ПОСТИГНУВА ГОЛ',
    'last_results': 'Последни резултати',
    'live_score': 'ВО ЖИВО',
    'teams': 'ТИМОВИ',
    'team': 'ТИМ',
    'pts': 'ПОЕ',
    'pos': 'ПОЗ',
    'please_login': 'Ве молам пријавете се',
    'minimum_stake_is': 'Минимален влог е',
    'maximum_stake_is': 'Максимален влог е',
    'you_dont_have_enough_deposit': 'Немате доволно депозит ',
    'unknown_session_id': 'Непознат SessionID',
    'please_login': 'Ве молиме логирајте се за да ставите опклада!',
    'betting': 'Обложување',
    'statistics': 'Статистика',
    'tickets': 'Тикети',
    'amount': 'Сума',
    'no_of_rounds': 'Кола во претплата',
    'repeat_last': 'Повтори последни',
    'random_six': 'Случајни 6',
    'random': 'Cлучаен',
    'random_one': 'Cлучаен',
    'all_colors': 'Сите Бои',
    'hot_six': '6 Hot',
    'cold_six': '6 Cold',
    'buy_ticket': 'Купи Тикет',
    'chosen_ticket_combination': 'Одбрана комбинација',
    'all_of_the_balls': 'Сите топчиња',
    'more_odd': 'Непарни',
    'more_even': 'Парни',
    'less': 'Под',
    'more': 'Над',
    'even': 'Пар',
    'odd': 'Неп',
    'first_five_balls': 'Збир на први 5',
    'first_ball': 'Прв број',
    'last_ball': 'Последен број',
    'top_color': 'Најчеста боја',
    'red': 'Црвена',
    'green': 'Зелена',
    'blue': 'Сина',
    'purple': 'Виолетова',
    'brown': 'Кафеава',
    'yellow': 'Жолта',
    'orange': 'Портокалова',
    'black': 'Црна',
    'silver': 'Црна',
    'the_most_common_numbers': 'Најчести броеви',
    'the_rarest_numbers': 'Најретки броеви',
    'ticket_id': 'Број на тикет',
    'all': 'Сите',
    'common_color': 'Најчеста боја',
    'parity': 'Пар/Непар',
    'round_no': 'Коло Бр.',
    'jackpot_code': 'ЏЕКПОТ Код',
    'purchased_a_ticket': 'Успешно купивте тикет',
    'chose_some_bets': 'Одберите комбинација пред да уплатите тикет',
    'winner': 'Победник',
    'w': 'W',
    'l': 'L',
    'FORM': 'Form',
    'place': '1,2',
    'show': '1,2,3',
    'second': 'Втори',
    'third': 'Трети',
    'trifecta': 'Трифекта',
    'perfecta': 'Перфекта',
    'double_chance': 'Дупла Шанса',
    'low': 'Помалку',
    'high': 'Повеќе',
    'sum': 'Сума',
    'jackpot': 'ЏЕКПОТ',
    'race': 'ТРКА',
    'mega_jackpot': 'МЕГА ЏЕКПОТ',
    'number_of_goals': 'БРОЈ НА ГОЛОВИ',
    'result': 'РЕЗУЛТАТ',
    'total_goals': 'ВКУПНО ГОЛОВИ',
    'correct_score': 'ТОЧЕН РЕЗУЛТАТ',
    'ht': 'ПО.',
    'ft': 'КР.',
    'ht_ft': 'ПОЛ./КРАЈ',
    'next': 'СЛЕДНА',
    'half_time_full_time': 'ПОЛУВРЕМЕ / КРАЈ',
    'over_under': 'ГРАНИЦИ',
    'full_time_goals_combination': 'КОНЕЧЕН ИСХОД / ГОЛОВИ',
    'gg_ng': 'GG / NG',
    'double_chance_gg_ng': 'ДУПЛА ШАНСА + GG / NG',
    'home': 'ДОМАЌИН',
    'away': 'ГОСТИН',
    'general_statistics': 'Општа Статистики',
    'odd_even': 'НЕП/ПАР',
    'odd_even_home': 'НЕПАР / ПАР ДОМАЌИН',
    'odd_even_away': 'НЕПАР / ПАР ГОСТИН',
    'home_score': 'ДОМАЌИН ДАВА ГОЛ',
    'away_score': 'ГОСТИН ДАВА ГОЛ',
    'home_ou': 'ДОМАЌИН OU',
    'away_ou': 'ГОСТИН OU',
    'uo15_1x2': 'UO15 + 1X2',
    'uo25_1x2': 'UO25 + 1X2',
    'gg_ng_over_under': 'GG / NG ГРАНИЦИ',
    'first_half': 'ПРВО ПОЛУВРЕМЕ',
    'slip': 'Тикет',
    'bet_slip': 'ТИКЕТ',
    'combinations': 'Комбинации',
    'system': 'Систем',
    'total_odd': 'Вкупна Квота',
    'total_stake': 'Вкупна Сума',
    'potential_maximal_win': 'Потенцијална добивка',
    'place_bet': 'Купи Тикет',
    'favorites': 'Фаворити',
    'underdogs': 'Аутсајдери',
    'please_choose': 'Ве молиме одберете го облогот',
    'open': 'ОТВОРЕНО',
    'chose_valid_amount': 'Одберете валидна сума на уплата',
    'no_tickets_for_current_game': 'Нема тикети за тековна игра',
    'game': 'Игра',
    'apple_video_no_support': 'Вашиот Apple телефон не подржува видео стреаминг. Ажурирајте на верзија на iOS 10+',
    'color': 'Боја',
    'error_purchasing_ticket': 'Грешка во купување на тикет',
    'choose_1_2_4_common': 'Одберете 1,2 или 4 бои за најчеста боја',
    'choose_1_2_4_first': 'Одберете 1,2 или 4 бои за боја на прв број',
    'choose_1_2_4_last': 'Одберете 1,2 или 4 бои за боја на последен број',
    'confirm_buying': 'OK',
    'cancel_buying': 'Откажи',
    'buying_title': 'Дали сигурно сакате да уплатите тикет?',
    'please_wait': 'Ве молиме почекајте...',
    'tutorial_close': 'ЗАТВОРИ',
    'tutorial_next': 'СЛЕДНО',
    'tutorial_back': 'НАЗАД',
    'tutorial_1': 'Ова кратко упатство ќе ви објасни како да се обложувате на "Lucky Balls"',
    'tutorial_2': 'Тука можете да ги изберете вашите броеви. Изберете од 6 до 10 бројки.',
    'tutorial_3': 'Можете да изберете облози како пар/непар, најчеста боја и сл. со клик на копчињата и/или боите на облозите.',
    'tutorial_4': 'Изберете износ на влогот: минимален, максимален, некоја од трите прикажани вредности или внесете ваш износ.',
    'tutorial_5': 'Изберете број на извлекувања.',
    'tutorial_6': 'Со клик на „Купи тикет" вашиот облог ќе биде прифатен.',
    'tutorial_7': 'Во овој дел од екранот можете да ги следите вашите тикети во тек на извлекувањето. Извлечените броеви и добитни облози ќе бидат обележани со различна боја. Насловот на добитните тикети ќе биде обележан со зелено.',
    'tutorial_8': 'Можете да го следите извлекувањето во овој дел од екранот.',
    'tutorial_9': 'Различни статистики можат да ви помогнат да ја креирате вашата добитна комбинација.',
    'help': 'Помош',
    'tickets-vfl': 'Tikets/Stats',
    'results': 'RESULTS',
    'for_draw': 'За Извлекување',
    'draw': 'Нерешено',
    'd': 'D',
    'results_lower': 'Резултати',
    'round_completed': 'ROUND COMPLETED',
    'first_5_no_award': 'FIRST 5 BALLS WITHOUT AWARD',
    'last_bets': 'Last bets please!',
    'color_betting': 'Color Betting',
    'preballs_sum': 'Првите 5',
    'bonus_numbers': 'Bonus numbers',
    'current_round': 'Current round',
    'rounds_total': 'rounds total',
    'value': 'Value',
    'quick_lucky_ball': 'Quick Lucky Ball',
    'Login': 'Логирај се',
    'Logout': 'Одјава',
    'login_credentials': 'Акредитиви за најава',
    'Username': 'Корисничко име',
    'Password': 'Лозинка',
    'request_payout': 'Барање исплата',
    'payout_pin': 'ПИН за исплата',
    'Ok': 'Ok',
    'auth_failed': 'Грешка: автентикацијата не успеа',
    'enter_alias': 'Внесете алијас',
    'Submit': 'Поднесете',
    'Chat': 'Чет',
    'win_multiplier': 'ПОБЕДУВА МУЛТИПЛИЕР',
    'win_amount': 'ПОБЕДИ ПОМОШ',
    'first_color': 'ПРВИОТ БОЈА',
    'sure2share': 'Дали сте сигурни дека сакате да споделите?',
    'Share': 'Сподели',
    'chat_message': 'Чет порака',
    'yes': 'Да',
    'no': 'Не',
    'welcome': 'Добредојдовте',
    'credit_balance': 'Кредитен биланс:',
    'last_color': 'Последна боја',
    'last_ball_parity': 'Последен број Пар/Неп',
    'ticket_amount_less': 'Износот на тикет не може да биде помал од ',
    'ticket_amount_more': 'Износот на тикет не може да биде поголем од '
};

langArr['ba'] = {
    'odds': 'Kvote',
    'popular': 'POPULRNO',
    'standings': 'Stanje',
    'final_score': 'KONAČAN ISHOD',
    'home_goals': 'DOMAĆIN GOLOVI',
    'away_goals': 'GOST GOLOVI',
    'score': 'DAJE GOL',
    'last_results': 'Poslednji rezultati',
    'live_score': 'UŽIVO',
    'teams': 'TIMOVI',
    'team': 'TIM',
    'pts': 'POE',
    'pos': 'POZ',
    'please_login': 'Molimo Vas da se ulogujete',
    'minimum_stake_is': 'Minimalan ulog je',
    'maximum_stake_is': 'Maksimalan ulog je',
    'you_dont_have_enough_deposit': 'Nemate dovoljno depozita',
    'unknown_session_id': 'Nepoznat SessionID',
    'please_login': 'Molimo Vas da se ulogujete da bi ste uplatili tiket!',
    'betting': 'Klađenje',
    'statistics': 'Statistika',
    'tickets': 'Tiketi',
    'amount': 'Iznos',
    'no_of_rounds': 'Br. Izvlačenja',
    'repeat_last': 'Ponovi Opkladu',
    'random_six': 'Nasumičnih 6',
    'random': 'Slučajni',
    'random_one': 'Slučajni',
    'all_colors': 'Sve Boje',
    'hot_six': 'Najčešćih 6',
    'cold_six': 'Najređih 6',
    'buy_ticket': 'Uplati Tiket',
    'chosen_ticket_combination': 'Odabrana Kombinacija',
    'all_of_the_balls': 'Sve Loptice',
    'more_odd': 'Više Neparnih',
    'more_even': 'Više Parnih',
    'less': 'Manje',
    'more': 'Više',
    'even': 'Par.',
    'odd': 'Nep.',
    'first_five_balls': 'Prvih 5',
    'first_ball': 'Prva Loptica',
    'last_ball': 'Posljednja Loptica',
    'top_color': 'Najčešća Boja',
    'red': 'Crvena',
    'green': 'Zelena',
    'blue': 'Plava',
    'purple': 'Ljubičasta',
    'brown': 'Braon',
    'yellow': 'Žuta',
    'orange': 'Narandžasta',
    'black': 'Crna',
    'silver': 'Crna',
    'the_most_common_numbers': 'Najčešći brojevi',
    'the_rarest_numbers': 'Najrjeđi brojevi',
    'ticket_id': 'Broj Tiketa',
    'all': 'Sve Loptice',
    'common_color': 'Najčešća Boja',
    'parity': 'Par/Nepar',
    'round_no': 'Igra Br.',
    'jackpot_code': 'Jackpot Kod',
    'purchased_a_ticket': 'Uspješno ste uplatili tiket!',
    'chose_some_bets': 'Odaberite opkladu da bi uplatili tiket!',
    'winner': 'Pobjednik',
    'w': 'P',
    'l': 'I',
    'FORM': 'Form',
    'place': 'U prva dva',
    'show': 'U prva tri',
    'second': 'Drugo Mjesto',
    'third': 'Treće mjesto',
    'trifecta': 'Trifekta',
    'perfecta': 'Perfekta',
    'double_chance': 'Dupla Šansa',
    'low': 'Manje',
    'high': 'Više',
    'sum': 'Suma',
    'jackpot': 'JACKPOT',
    'race': 'TRKA',
    'mega_jackpot': 'Mega Jackpot',
    'regional_jackpot': 'Regionalni Jackpot',
    'weldmag_regional_jackpot': 'SUPERBONUS',
    'weldmag_jackpot':'WELDPOT',
    'number_of_goals': 'BROJ GOLOVA',
    'result': 'REZULTAT',
    'total_goals': 'UKUPNO GOLOVA',
    'correct_score': 'TAČAN REZULTAT',
    'ht': 'PO',
    'ft': 'KR',
    'ht_ft': 'POLUVRIJEME-KRAJ',
    'next': 'SLJEDEĆA',
    'half_time_full_time': 'POLUVRIJEME-KRAJ',
    'over_under': 'GOLOVI',
    'full_time_goals_combination': 'KONAČAN ISHOD / GOLOVI',
    'gg_ng': 'GG / NG',
    'double_chance_gg_ng': 'DUPLA ŠANSA+ GG / NG',
    'home': 'DOMAĆIN',
    'away': 'GOST',
    'general_statistics': 'Generalna Statistika',
    'odd_even': 'NEP/PAR',
    'odd_even_home': 'NEPARAN/PARAN DOMAĆIN',
    'odd_even_away': 'NEPARAN/PARAN GOST',
    'home_score': 'GOLOVA DOMAĆIN',
    'away_score': 'GOLOVA GOST',
    'home_ou': 'DOMAĆIN GOLOVI',
    'away_ou': 'GOST GOLOVI',
    'uo15_1x2': 'UO15 + 1X2',
    'uo25_1x2': 'UO25 + 1X2',
    'gg_ng_over_under': 'GG / NG GOLOVI',
    'first_half': 'PRVO POLUVRIJEME',
    'slip': 'Tiket',
    'bet_slip': 'Tiket',
    'combinations': 'Kombinacija',
    'system': 'Sistem',
    'total_odd': 'Ukupna Kvota',
    'total_stake': 'Iznos Uplate',
    'potential_maximal_win': 'Eventualni Dobitak',
    'place_bet': 'Uplati Tiket',
    'favorites': 'Favoriti',
    'underdogs': 'Outsajderi',
    'please_choose': 'Odaberite opkladu da bi uplatili tiket!',
    'open': 'OTVOREN',
    'chose_valid_amount': 'Izaberite ispravnu cifru opklade',
    'no_tickets_for_current_game': 'Nema tiketa za igru u toku',
    'game': 'Igra',
    'apple_video_no_support': 'Vaš apple uredjaj ne podržava strimovanje videa, ažurirajte software na iOS10+ da bi mogli da gledate video snimke.',
    'color': 'Boja',
    'error_purchasing_ticket': 'Greška prilikom kupovine tiketa.',
    'choose_1_2_4_common': 'Odaberite jednu, dvije ili četiri boje za najčešću boju',
    'choose_1_2_4_first': 'Odaberite jednu, dvije ili četiri boje za prvu lopticu',
    'choose_1_2_4_last': 'Odaberite jednu, dvije ili četiri boje za posljednju lopticu',
    'confirm_buying': 'Potvrdi',
    'cancel_buying': 'Odustani',
    'buying_title': 'Da li ste sigurni da želite da uplatite tiket?',
    'please_wait': 'Molimo sačekajte...',
    'tutorial_close': 'ZATVORI',
    'tutorial_next': 'SLIJEDEĆI',
    'tutorial_back': 'NAZAD',
    'tutorial_1': 'Ovo kratko uputstvo će vam pokazati kako da unesete opkladu na igri "Lucky Balls"',
    'tutorial_2': 'Ovdje birate vaše brojeve. Odaberite 6 do 10 brojeva.',
    'tutorial_3': 'Opklade na spoljne uloge (par/nepar, najčešća boja itd.) birate klikom na dugmiće i/ili boje spoljne opklade.',
    'tutorial_4': 'Odaberite iznos uplate: minimalni, maksimalni, tri predefinisane vrednosti ili unestite sami željeni iznos uplate.',
    'tutorial_5': 'Odaberite broj kola za igru unaprijed.',
    'tutorial_6': 'Klikom na "Uplati tiket" vaša opklada će biti unešena u sistem.',
    'tutorial_7': 'U ovom dijelu možete da pratite status vašeg tiketa tokom izvlačenja. Izvučeni brojevi i dobitne spoljne opklade će biti posebno označeni drugom bojom. Zaglavlje dobitnih tiketa je označeno zelenom bojom.',
    'tutorial_8': 'Izvlačenje kuglica možete da pratite na ovom delu ekrana, isto kao i da se nalazite u sportskoj kladionici.',
    'tutorial_9': 'Razne statistike vam mogu pomoći da uplatite vašu dobitnu kombinaciju.',
    'help': 'Pomoć',
    'tickets-vfl': 'Tiket/Stat.',
    'results': 'REZULTATI',
    'for_draw': 'Za Izvlačenje',
    'draw': 'Nerešeno',
    'd': 'N',
    'results_lower': 'Rezultati',
    'round_completed': 'ROUND COMPLETED',
    'first_5_no_award': 'FIRST 5 BALLS WITHOUT AWARD',
    'last_bets': 'Last bets please!',
    'color_betting': 'Color Betting',
    'preballs_sum': 'Prvih 5',
    'bonus_numbers': 'Bonus numbers',
    'current_round': 'Current round',
    'rounds_total': 'rounds total',
    'value': 'Broj',
    'quick_lucky_ball': 'Brzih 6',
    'Login': 'Uloguj se',
    'Logout': 'Izloguj se',
    'login_credentials': 'Kredencijali za logovanje',
    'Username': 'Korisničko ime',
    'Password': 'Password',
    'request_payout': 'Zahtev za isplatu',
    'payout_pin': 'PIN za isplatu',
    'Ok': 'Ok',
    'auth_failed': 'Greška: Neuspešna autentifikacija',
    'enter_alias': 'Unesi Alias',
    'Submit': 'Podnesi',
    'Chat': 'Čet',
    'win_multiplier': 'OSVOJI MULTIPLIKATOR',
    'win_amount': 'DOBITNI IZNOS',
    'first_color': 'PRVA BOJA',
    'sure2share': 'Jeste li sigurni da želite da podijelite??',
    'Share': 'Podijeliti',
    'chat_message': 'Čet poruka',
    'yes': 'Da',
    'no': 'Ne',
    'welcome': 'Dobrodošli',
    'credit_balance': 'Stanje na računu ',
    'last_color': 'Zadnja boja',
    'last_ball_parity': 'Poslednja Loptica Par/Nep',
    'ticket_amount_less': 'Iznos tiketa ne može biti manji od ',
    'ticket_amount_more': 'Iznos tiketa ne može biti veći od '
};

langArr['de'] = {
    'odds': 'Chancen',
    'popular': 'BELIEBT',
    'standings': 'Rangliste',
    'final_score': 'ENDERGEBNIS',
    'home_goals': 'HEIMMANNSCHAFT  GOL',
    'away_goals': 'GASTMANNSCHAFT GOL',
    'score': 'SCHIEßT',
    'last_results': 'LETZTES ERGEBNIS',
    'live_score': 'LIVEWETTEN',
    'teams': 'TEAMS',
    'team': 'TEAM',
    'pts': 'Pun',
    'pos': 'POS',
    'please_login': 'Loggen bite',
    'minimum_stake_is': 'Mindesteinsatz ist',
    'maximum_stake_is': 'Maximaler Einsatz ist',
    'you_dont_have_enough_deposit': 'Sie haben nicht genug Einzahlung',
    'unknown_session_id': 'Unbekannte SessionID',
    'please_login': 'Bitte loggen Sie sich ein!',
    'betting': 'Wetten',
    'statistics': 'Statistiken',
    'tickets': 'Tickets',
    'amount': 'Betrag',
    'no_of_rounds': 'Anz. der Rund.',
    'repeat_last': 'Zuletzt wiederholen',
    'random_six': 'Random Six',
    'random': 'Zufällig',
    'random_one': 'Zufällig',
    'all_colors': 'Alle Farben',
    'hot_six': 'Hot Six',
    'cold_six': 'Cold Six',
    'buy_ticket': 'Ticket kaufen',
    'chosen_ticket_combination': 'Gewählte Ticketkombination',
    'all_of_the_balls': 'Alle Bälle',
    'more_odd': 'Mehr unger.',
    'more_even': 'Mehr ger.',
    'less': 'Weniger',
    'more': 'Mehr',
    'even': 'Ger.',
    'odd': 'Unger.',
    'first_five_balls': 'Die ersten fünf Bälle',
    'first_ball': 'Erster Ball',
    'first_even_odd': 'Erster Ger/Unger',
    'last_even_odd': 'Letzter Ger/Unger',
    'last_ball': 'Letzter Ball',
    'top_color': 'Top-Farbe',
    'red': 'Rot',
    'green': 'Grün',
    'blue': 'blau',
    'purple': 'Purpur',
    'brown': 'Braun',
    'yellow': 'Gelb',
    'orange': 'Orange',
    'black': 'Schwarz',
    'silver': 'Schwarz',
    'the_most_common_numbers': 'Die häufigsten Zahlen',
    'the_rarest_numbers': 'Die seltensten Zahlen',
    'ticket_id': 'Ticket ID',
    'all': 'Alles',
    'common_color': ' Häufigste Farbe',
    'parity': ' Parität',
    'round_no': 'Runde Nummer (Nr.)',
    'jackpot_code': 'Jackpot Code',
    'purchased_a_ticket': ' Sie haben ein Ticket erfolgreich erworben',
    'chose_some_bets': 'Bitte wählen Sie einige Wetten aus, um ein Ticket zu kaufen',
    'winner': 'Gewinner',
    'w': 'S',
    'l': 'N',
    'FORM': 'VORH',
    'place': 'Platz',
    'show': 'Show',
    'second': 'Zweite',
    'third': 'Dritte',
    'trifecta': 'Trifecta',
    'perfecta': 'Perfecta',
    'double_chance': 'Doppelte Chance',
    'low': 'Low',
    'high': 'High',
    'sum': 'Summe',
    'jackpot': 'JACKPOT',
    'race': 'RACE',
    'mega_jackpot': 'Mega Jackpot',
    'regional_jackpot': 'Regionaler Jackpot',
    'weldmag_regional_jackpot': 'SUPERBONUS',
    'weldmag_jackpot':'WELDPOT',
    'number_of_goals': 'ANZAHL DER ZIELE',
    'result': 'ERGEBNIS',
    'total_goals': 'GESAMTZIELE',
    'correct_score': 'KORREKTES ERGEBNIS',
    'ht': 'HT',
    'ft': 'FT',
    'ht_ft': 'HT/FT',
    'next': 'WEITER',
    'half_time_full_time': 'HALBZEIT / VOLLZEIT',
    'over_under': 'ÜBER UNTER',
    'full_time_goals_combination': 'VOLLZEIT / ZIELE KOMBINATION',
    'gg_ng': 'GG / NG',
    'double_chance_gg_ng': 'DOPPELTE CHANCE + GG / NG',
    'home': 'HOME',
    'away': 'AWAY',
    'general_statistics': ' Allgemeine Statistiken',
    'odd_even': 'UNGE/GERA',
    'odd_even_home': 'UNGERADE / GERADE HOME',
    'odd_even_away': 'UNGERADE / GERADE AWAY',
    'home_score': 'HOME ERGEBNIS',
    'away_score': 'AWAY ERGEBNIS',
    'home_ou': 'HOME OU',
    'away_ou': 'AWAY OU',
    'uo15_1x2': 'UO15 + 1X2',
    'uo25_1x2': 'UO25 + 1X2',
    'gg_ng_over_under': 'GG / NG ÜBER UNTER',
    'first_half': 'ERSTE HÄLFTE',
    'slip': 'Slip',
    'bet_slip': 'WETTSCHEIN',
    'combinations': 'Kombinationen',
    'system': 'System',
    'total_odd': 'Total ungerade',
    'total_stake': 'Total Einsatz',
    'potential_maximal_win': 'Potential Maximal Win',
    'place_bet': 'Platz Wetten',
    'favorites': 'Favoriten',
    'underdogs': 'Underdogs',
    'please_choose': 'Bitte wählen Sie zuerst einige Wetten aus',
    'open': 'ÖFFNEN',
    'chose_valid_amount': 'Bitte wählen Sie einen gültigen Wettbetrag',
    'no_tickets_for_current_game': 'Es gibt keine Tickets für das aktuelle Spiel',
    'game': 'Spiel',
    'apple_video_no_support': 'Ihr Apple-Gerät unterstützt Video-Streaming nicht, bitte aktualisieren Sie auf iOS 10+, um Videos anzusehen.',
    'color': 'Farbe',
    'error_purchasing_ticket': 'Fehler beim Ticketkauf',
    'choose_1_2_4_common': 'Bitte wählen Sie 1, 2 oder 4 Farben für die häufigste Farbe',
    'choose_1_2_4_first': 'Bitte wählen Sie 1, 2 oder 4 Farben für den ersten Ball',
    'choose_1_2_4_last': 'Bitte wählen Sie 1, 2 oder 4 Farben für den letzten Ball',
    'confirm_buying': 'OK',
    'cancel_buying': 'Abbrechen',
    'buying_title': 'Sind Sie sicher, dass Sie das Ticket kaufen möchten?',
    'please_wait': 'Bitte warten...',
    'tutorial_close': 'SCHLIEßEN',
    'tutorial_next': 'WEITER',
    'tutorial_back': 'ZURÜCK',
    'tutorial_1': 'Dieses kurze Tutorial erklärt Ihnen, wie Sie auf  Lucky Balls  wetten können. ',
    'tutorial_2': ' Hier können Sie Ihre Nummern auswählen. Wählen Sie 6 bis 10 Zahlen. ',
    'tutorial_3': ' Sie können Wetten wie gerade / ungerade, Top-Farbe usw. durch Klicken des Buttons und / oder Farben einer Wette wählen. ',
    'tutorial_4': ' Wählen Sie den Betrag der Wette: minimal, maximal, drei präsentierte Werte oder geben Sie einen benutzerdefinierten Betrag ein. ',
    'tutorial_5': ' Wählen Sie eine Anzahl von Spielrunden.',
    'tutorial_6': 'Mit einem Klick auf "Ticket kaufen" wird Ihre Wette angenommen.',
    'tutorial_7': 'In diesem Teil eines Bildschirms können Sie Ihre Tickets während der Runde überwachen. Gezeichnete Zahlen und gewinnende Wetten werden auf dem Ticket mit verschiedenen Farben markiert. Kopfball der gewinnenden Tickets wird grün markiert.',
    'tutorial_8': 'In diesem Teil des Bildschirms können Sie das Zeichnen von Bällen beobachten.',
    'tutorial_9': '‚Verschiedene Statistiken können Ihnen helfen, Ihre Gewinnkombination zu machen.',
    'help': 'Hilfe',
    'tickets-vfl': 'Tickets/Stats',
    'results': 'ERGEBNISSE',
    'for_draw': 'Zum Ziehen',
    'draw': 'Ungelöst',
    'd': 'U',
    'results_lower': 'Ergebnisse',
    'round_completed': 'RUNDE ABGESCHLOSSEN',
    'first_5_no_award': 'ERSTE 5 BÄLLE OHNE PREIS',
    'last_bets': 'Letzte Einsätze bitte!',
    'color_betting': 'Farb Wetten',
    'preballs_sum': 'Erste 5',
    'bonus_numbers': 'Bonus Nummer',
    'current_round': 'Current round',
    'rounds_total': 'rounds total',
    'value': 'Value',
    'quick_lucky_ball': 'Quick Lucky Ball',
    'Login': 'Einloggen',
    'Logout': 'Ausloggen',
    'login_credentials': 'Anmeldedaten',
    'Username': 'Nutzername',
    'Password': 'Passwort',
    'request_payout': 'Auszahlung anfordern',
    'payout_pin': 'Auszahlungs-PIN',
    'Ok': 'Ok',
    'auth_failed': 'Fehler: Authentifizierung fehlgeschlagen',
    'enter_alias': 'Alias eingeben',
    'Submit': 'Einreichen',
    'Chat': 'Chat',
    'win_multiplier': 'WIN MULTIPLIER',
    'win_amount': 'GEWINNEN SIE BETRAG',
    'first_color': 'ERSTE FARBE',
    'sure2share': 'Bist du sicher, dass du teilen möchtest?',
    'Share': 'Aktie',
    'chat_message': 'Chat-Nachricht',
    'yes': 'Ja',
    'no': 'Nein',
    'welcome': 'Herzlich willkommen',
    'credit_balance': 'Kontostand : ',
    'last_color': 'Letzte Farbe',
    'last_ball_parity': 'Letzter Ball Ger/Unger',
    'ticket_amount_less': 'Der Ticket darf nicht geringer sein als ',
    'ticket_amount_more': 'Der Ticket kann nicht größer als sein  '
};

langArr['al'] = {
    'odds': 'Kuotat',
    'popular': 'POPULAR',
    'standings': 'Renditja',
    'final_score': 'REZULTATI I PËRFUNDUAR',
    'home_goals': 'Gol ekipi i Shtëpisë',
    'away_goals': 'Gol ekipi i ftuar',
    'score': 'SHENON',
    'last_results': 'Rezultatet e fundit',
    'live_score': 'Live Score',
    'teams': 'EKIPET',
    'team': 'EKIPI',
    'pts': 'Pik',
    'pos': 'POZ',
    'please_login': 'ju lutemi identifikohuni',
    'minimum_stake_is': 'Vlera minimale është',
    'maximum_stake_is': 'Maksimumi i aksioneve është',
    'you_dont_have_enough_deposit': 'Ju nuk keni depozita të mjaftueshme',
    'unknown_session_id': 'Unknown SessionID',
    'betting': 'Vënia e bastit',
    'statistics': 'Statistikat',
    'tickets': 'Tiketat',
    'amount': 'Shuma',
    'no_of_rounds': 'Nr. i raun.',
    'repeat_last': 'Përsërit bastin',
    'random_six': '6 të rastësishëm',
    'random': 'Rastësishëm',
    'random_one': 'Rastësishëm',
    'all_colors': 'Të gjitha ngjyrat',
    'hot_six': 'Hot Six',
    'cold_six': 'Cold Six',
    'buy_ticket': 'Paguaj tiketën',
    'chosen_ticket_combination': 'Kombinimi i zgjedhur',
    'all_of_the_balls': 'Të gjithë topat',
    'more_odd': 'Më shumë tek',
    'more_even': 'Më shumë çift',
    'less': 'Më pakë',
    'more': 'Më shum',
    'even': 'Çift',
    'odd': 'Tek',
    'first_five_balls': '5 topat e parë',
    'first_ball': 'Topi i parë',
    'last_ball': 'Topi i fundit',
    'top_color': 'Ngjyra më e shpeshtë',
    'red': 'E kuqe',
    'green': 'E gjelbër',
    'blue': 'E kaltër',
    'purple': 'Ngjyrë vjollcë',
    'brown': 'Ngjyrë kafe',
    'yellow': 'E verdhë',
    'orange': 'Portokalli',
    'black': 'E zezë',
    'silver': 'Ngjyrë hiri',
    'the_most_common_numbers': 'Numrat më të shpeshtë',
    'the_rarest_numbers': 'Numrat më të rrallë',
    'ticket_id': 'Numri i tiketës',
    'all': 'Të gjithë topat',
    'common_color': 'Ngjyra më e shpeshtë',
    'parity': 'Çift/Tek',
    'round_no': 'Raundi nr.',
    'jackpot_code': 'Kodi i Jackpot-it',
    'purchased_a_ticket': 'Pagesë e suksesshme e tiketës!',
    'chose_some_bets': 'Zgjidhni bastin për të paguar tiketën!',
    'winner': 'Fituesi',
    'w': 'F',
    'l': 'H',
    'FORM': 'Forma',
    'place': 'Në dy të parët',
    'show': 'Në tre të parët',
    'second': 'Vendi i dytë',
    'third': 'Vendi i tretë',
    'trifecta': 'Trifekta',
    'perfecta': 'Perfekta',
    'double_chance': 'Shans i dyfishtë',
    'low': 'Më pakë',
    'high': 'Më shumë',
    'sum': 'Shuma',
    'jackpot': 'JACKPOT',
    'race': 'GARA',
    'mega_jackpot': 'Mega Jackpot',
    'regional_jackpot': 'Rajonal Jackpot',
    'weldmag_regional_jackpot': 'SUPERBONUS',
    'weldmag_jackpot':'WELDPOT',
    'number_of_goals': 'NUMRI I GOLAVE',
    'result': 'REZULTATI',
    'total_goals': 'GJITHSEJ GOLA',
    'correct_score': 'REZULTAT I SAKTË',
    'ht': 'PJ.',
    'ft': 'FU.',
    'ht_ft': 'PJESA E PARË-FUNDI',
    'next': 'TJETRA',
    'half_time_full_time': 'PJESA E PARË-FUNDI',
    'over_under': 'GOLAT',
    'full_time_goals_combination': 'REZULTATI PËRFUNDIMTAR / GOLAT',
    'gg_ng': 'GG / NG',
    'double_chance_gg_ng': 'SHANS I DYFISHTË+ GG / NG',
    'home': 'VENDASI',
    'away': 'MYSAF.',
    'general_statistics': 'Statistikat e përgjithshme',
    'odd_even': 'TEK/ÇIFT',
    'odd_even_home': 'VENDASI TEK/ÇIFT',
    'odd_even_away': 'MYSAFIRI TEK/ÇIFT',
    'home_score': 'GOLAT SI VENDAS',
    'away_score': 'GOLAT SI MYSAFIR',
    'home_ou': 'GOLAT VENDASI',
    'away_ou': 'GOLAT MYSAFIRI',
    'uo15_1x2': 'UO15 + 1X2',
    'uo25_1x2': 'UO25 + 1X2',
    'gg_ng_over_under': 'GG / NG GOLAT',
    'first_half': 'PJESA E PARË',
    'slip': 'Tiketa',
    'bet_slip': 'Tiketa',
    'combinations': 'Kombinimi',
    'system': 'Sistemi',
    'total_odd': 'Kuota totale',
    'total_stake': 'Shuma e pagesës',
    'potential_maximal_win': 'Fitimi i mundshëm',
    'place_bet': 'Paguaj tiketën',
    'favorites': 'Favoritët',
    'underdogs': 'Autsajderat',
    'please_choose': 'Zgjidhni bastin për të paguar tiketën!',
    'open': 'HAPUR',
    'chose_valid_amount': 'Zgjidhni shifrën e duhur të bastit',
    'no_tickets_for_current_game': 'Nuk ka tiketë për lojën aktuale',
    'game': 'Loja',
    'apple_video_no_support': 'Pajisja juaj Apple nuk mbështet video streaming, përditësoni softuerin në iOS10+ që të mund të shihni videot.',
    'color': 'Ngjyra',
    'error_purchasing_ticket': 'Gabim gjatë blerjes së tiketës.',
    'choose_1_2_4_common': 'Zgjidhni një, dy apo katër ngjyra për ngjyrën më të shpeshtë',
    'choose_1_2_4_first': 'Zgjidhni një, dy apo katër ngjyra për topin e parë',
    'choose_1_2_4_last': 'Zgjidhni një, dy apo katër ngjyra për topin e fundit',
    'confirm_buying': 'Konfirmo',
    'cancel_buying': 'Anulo',
    'buying_title': 'A jeni i sigurt që dëshironi të paguani tiketën?',
    'please_wait': 'Ju lutem prisni...',
    'tutorial_close': 'MBYLL',
    'tutorial_next': 'TJETRI',
    'tutorial_back': 'MBRAPA',
    'tutorial_1': 'Ky udhëzim i shkurtër do t’ju tregojë si të vëni një bast në lojën "Lucky Balls"',
    'tutorial_2': 'Këtu përzgjidhni numrat tuaj. Zgjidhni 6 deri në 10 numra.',
    'tutorial_3': 'Bastet në depozitat e jashtme (çift/tek, ngjyra më e shpeshtë etj.) i zgjidhni duke klikuar në butonat dhe/ose ngjyrat e basteve të jashtëm.',
    'tutorial_4': 'Zgjidhni shumën e pagesës: minimale, maksimale, tri vlera të paracaktuara apo vendosni vetë shumën e dëshiruar të pagesës',
    'tutorial_5': 'Zgjidhni vetë numrat e xhirove për lojë paraprakisht.',
    'tutorial_6': 'Duke klikuar në "Paguaj tiketën" basti juaj do të futet në sistem.',
    'tutorial_7': 'Në këtë pjesë mund të ndiqni statusin e tiketës suaj gjatë tërheqjes. Numrat e tërhequr dhe bastet e jashtëm fitues do të shënjohen në mënyrë të veçantë me ngjyrë tjetër. Kreu i tiketave fituese është shënjuar me ngjyrë të gjelbër.',
    'tutorial_8': 'Tërheqjen e sferave mund ta ndiqni në këtë pjesë të ekranit, njëjtë sikur të gjendeni në bastore sportive.',
    'tutorial_9': 'Statistikat e ndryshme mund të ju ndihmojnë që të paguani kombinimin tuaj fitues.',
    'help': 'Ndihmë',
    'tickets-vfl': 'Tiketa/Stat.',
    'results': 'REZULTATET',
    'draw': 'Barazim',
    'd': 'B',
    'results_lower': 'Rezultatet',
    'round_completed': 'LOJA KA PËRFUNDUAR',
    'first_5_no_award': '5 TOPAT E PARË',
    'last_bets': 'Depozitat e fundit!',
    'color_betting': 'Vënia bast në ngjyra',
    'preballs_sum': '5 topat e parë',
    'bonus_numbers': 'Numrat bonus',
    'current_round': 'Raundi aktual',
    'rounds_total': 'Gjithsej raunde',
    'value': 'Value',
    'quick_lucky_ball': 'Quick Lucky Ball',
    'Login': 'Hyrje',
    'Logout': 'Shkyç',
    'login_credentials': 'Kredencialet e hyrjes',
    'Username': 'Emri i përdoruesit',
    'Password': 'Fjalëkalim',
    'request_payout': 'Kërkoni pagesa',
    'payout_pin': 'PIN i pagesës',
    'Ok': 'Ok',
    'auth_failed': 'Gabim: Autentifikimi dështoi',
    'enter_alias': 'Shkruaj pseudonimin',
    'Submit': 'Paraqes',
    'Chat': 'Chat',
    'win_multiplier': 'FITO MULTIPLIER',
    'win_amount': 'FITO SHUM',
    'first_color': 'NGJYRA E PAR',
    'sure2share': 'A jeni i sigurt se doni të ndani?',
    'Share': 'Pjesë',
    'chat_message': 'Chat mesazh',
    'yes': 'Po',
    'no': 'Jo',
    'welcome': 'I mirëpritur',
    'credit_balance': 'Gjendja e kreditit: ',
    'last_color': 'Ngjyra e fundit',
    'last_ball_parity': 'Topi i fundit  Çift/Tek',
    'ticket_amount_less': 'Shuma e tiketën mund të mos jetë më e vogël se ',
    'ticket_amount_more': 'Shuma e tiketën nuk mund të jetë më e madhe se  '
};

langArr['sq'] = {
    'odds': 'Kuotat',
    'popular': 'POPULAR',
    'standings': 'Renditja',
    'final_score': 'REZULTATI I PËRFUNDUAR',
    'home_goals': 'Gol ekipi i Shtëpisë',
    'away_goals': 'Gol ekipi i ftuar',
    'score': 'SHENON',
    'last_results': 'Rezultatet e fundit',
    'live_score': 'Live Score',
    'teams': 'EKIPET',
    'team': 'EKIPI',
    'pts': 'Pik',
    'pos': 'POZ',
    'please_login': 'ju lutemi identifikohuni',
    'minimum_stake_is': 'Vlera minimale është',
    'maximum_stake_is': 'Maksimumi i aksioneve është',
    'you_dont_have_enough_deposit': 'Ju nuk keni depozita të mjaftueshme',
    'unknown_session_id': 'Unknown SessionID',
    'betting': 'Vënia e bastit',
    'statistics': 'Statistikat',
    'tickets': 'Tiketat',
    'amount': 'Shuma',
    'no_of_rounds': 'Nr. i raundeve',
    'repeat_last': 'Përsërit bastin',
    'random_six': '6 të rastësishëm',
    'random': 'Rastësishëm',
    'random_one': 'Rastësishëm',
    'all_colors': 'Të gjitha ngjyrat',
    'hot_six': 'Hot Six',
    'cold_six': 'Cold Six',
    'buy_ticket': 'Paguaj tiketën',
    'chosen_ticket_combination': 'Kombinimi i zgjedhur',
    'all_of_the_balls': 'Të gjithë topat',
    'more_odd': 'Më shumë tek',
    'more_even': 'Më shumë çift',
    'less': 'Më pakë',
    'more': 'Më shumë',
    'even': 'Çift',
    'odd': 'Tek',
    'first_five_balls': '5 topat e parë',
    'first_ball': 'Topi i parë',
    'last_ball': 'Topi i fundit',
    'top_color': 'Ngjyra më e shpeshtë',
    'red': 'E kuqe',
    'green': 'E gjelbër',
    'blue': 'E kaltër',
    'purple': 'Ngjyrë vjollcë',
    'brown': 'Ngjyrë kafe',
    'yellow': 'E verdhë',
    'orange': 'Portokalli',
    'black': 'E zezë',
    'silver': 'Ngjyrë hiri',
    'the_most_common_numbers': 'Numrat më të shpeshtë',
    'the_rarest_numbers': 'Numrat më të rrallë',
    'ticket_id': 'Numri i tiketës',
    'all': 'Të gjithë topat',
    'common_color': 'Ngjyra më e shpeshtë',
    'parity': 'Çift/Tek',
    'round_no': 'Raundi nr.',
    'jackpot_code': 'Kodi i Jackpot-it',
    'purchased_a_ticket': 'Pagesë e suksesshme e tiketës!',
    'chose_some_bets': 'Zgjidhni bastin për të paguar tiketën!',
    'winner': 'Fituesi',
    'w': 'F',
    'l': 'H',
    'FORM': 'Forma',
    'place': 'Në dy të parët',
    'show': 'Në tre të parët',
    'second': 'Vendi i dytë',
    'third': 'Vendi i tretë',
    'trifecta': 'Trifekta',
    'perfecta': 'Perfekta',
    'double_chance': 'Shans i dyfishtë',
    'low': 'Më pakë',
    'high': 'Më shumë',
    'sum': 'Shuma',
    'jackpot': 'JACKPOT',
    'race': 'GARA',
    'mega_jackpot': 'Mega Jackpot',
    'regional_jackpot': 'Rajonal Jackpot',
    'weldmag_regional_jackpot': 'SUPERBONUS',
    'weldmag_jackpot':'WELDPOT',
    'number_of_goals': 'NUMRI I GOLAVE',
    'result': 'REZULTATI',
    'total_goals': 'GJITHSEJ GOLA',
    'correct_score': 'REZULTAT I SAKTË',
    'ht': 'PJ.',
    'ft': 'FU.',
    'ht_ft': 'PJESA E PARË-FUNDI',
    'next': 'TJETRA',
    'half_time_full_time': 'PJESA E PARË-FUNDI',
    'over_under': 'GOLAT',
    'full_time_goals_combination': 'REZULTATI PËRFUNDIMTAR / GOLAT',
    'gg_ng': 'GG / NG',
    'double_chance_gg_ng': 'SHANS I DYFISHTË+ GG / NG',
    'home': 'VENDASI',
    'away': 'MYSAF.',
    'general_statistics': 'Statistikat e përgjithshme',
    'odd_even': 'TEK/ÇIFT',
    'odd_even_home': 'VENDASI TEK/ÇIFT',
    'odd_even_away': 'MYSAFIRI TEK/ÇIFT',
    'home_score': 'GOLAT SI VENDAS',
    'away_score': 'GOLAT SI MYSAFIR',
    'home_ou': 'GOLAT VENDASI',
    'away_ou': 'GOLAT MYSAFIRI',
    'uo15_1x2': 'UO15 + 1X2',
    'uo25_1x2': 'UO25 + 1X2',
    'gg_ng_over_under': 'GG / NG GOLAT',
    'first_half': 'PJESA E PARË',
    'slip': 'Tiketa',
    'bet_slip': 'Tiketa',
    'combinations': 'Kombinimi',
    'system': 'Sistemi',
    'total_odd': 'Kuota totale',
    'total_stake': 'Shuma e pagesës',
    'potential_maximal_win': 'Fitimi i mundshëm',
    'place_bet': 'Paguaj tiketën',
    'favorites': 'Favoritët',
    'underdogs': 'Autsajderat',
    'please_choose': 'Zgjidhni bastin për të paguar tiketën!',
    'open': 'HAPUR',
    'chose_valid_amount': 'Zgjidhni shifrën e duhur të bastit',
    'no_tickets_for_current_game': 'Nuk ka tiketë për lojën aktuale',
    'game': 'Loja',
    'apple_video_no_support': 'Pajisja juaj Apple nuk mbështet video streaming, përditësoni softuerin në iOS10+ që të mund të shihni videot.',
    'color': 'Ngjyra',
    'error_purchasing_ticket': 'Gabim gjatë blerjes së tiketës.',
    'choose_1_2_4_common': 'Zgjidhni një, dy apo katër ngjyra për ngjyrën më të shpeshtë',
    'choose_1_2_4_first': 'Zgjidhni një, dy apo katër ngjyra për topin e parë',
    'choose_1_2_4_last': 'Zgjidhni një, dy apo katër ngjyra për topin e fundit',
    'confirm_buying': 'Konfirmo',
    'cancel_buying': 'Anulo',
    'buying_title': 'A jeni i sigurt që dëshironi të paguani tiketën?',
    'please_wait': 'Ju lutem prisni...',
    'tutorial_close': 'MBYLL',
    'tutorial_next': 'TJETRI',
    'tutorial_back': 'MBRAPA',
    'tutorial_1': 'Ky udhëzim i shkurtër do t’ju tregojë si të vëni një bast në lojën "Lucky Balls"',
    'tutorial_2': 'Këtu përzgjidhni numrat tuaj. Zgjidhni 6 deri në 10 numra.',
    'tutorial_3': 'Bastet në depozitat e jashtme (çift/tek, ngjyra më e shpeshtë etj.) i zgjidhni duke klikuar në butonat dhe/ose ngjyrat e basteve të jashtëm.',
    'tutorial_4': 'Zgjidhni shumën e pagesës: minimale, maksimale, tri vlera të paracaktuara apo vendosni vetë shumën e dëshiruar të pagesës',
    'tutorial_5': 'Zgjidhni vetë numrat e xhirove për lojë paraprakisht.',
    'tutorial_6': 'Duke klikuar në "Paguaj tiketën" basti juaj do të futet në sistem.',
    'tutorial_7': 'Në këtë pjesë mund të ndiqni statusin e tiketës suaj gjatë tërheqjes. Numrat e tërhequr dhe bastet e jashtëm fitues do të shënjohen në mënyrë të veçantë me ngjyrë tjetër. Kreu i tiketave fituese është shënjuar me ngjyrë të gjelbër.',
    'tutorial_8': 'Tërheqjen e sferave mund ta ndiqni në këtë pjesë të ekranit, njëjtë sikur të gjendeni në bastore sportive.',
    'tutorial_9': 'Statistikat e ndryshme mund të ju ndihmojnë që të paguani kombinimin tuaj fitues.',
    'help': 'Ndihmë',
    'tickets-vfl': 'Tiketa/Stat.',
    'results': 'REZULTATET',
    'draw': 'Barazim',
    'd': 'B',
    'results_lower': 'Rezultatet',
    'round_completed': 'LOJA KA PËRFUNDUAR',
    'first_5_no_award': '5 TOPAT E PARË',
    'last_bets': 'Depozitat e fundit!',
    'color_betting': 'Vënia bast në ngjyra',
    'preballs_sum': '5 topat e parë',
    'bonus_numbers': 'Numrat bonus',
    'current_round': 'Raundi aktual',
    'rounds_total': 'Gjithsej raunde',
    'value': 'Value',
    'quick_lucky_ball': 'Quick Lucky Ball',
    'Login': 'Hyrje',
    'Logout': 'Shkyç',
    'login_credentials': 'Kredencialet e hyrjes',
    'Username': 'Emri i përdoruesit',
    'Password': 'fjalëkalim',
    'request_payout': 'Kërkoni pagesa',
    'payout_pin': 'PIN i pagesës',
    'Ok': 'Ok',
    'auth_failed': 'Gabim: Autentifikimi dështoi',
    'enter_alias': 'Shkruaj pseudonimin',
    'Submit': 'Paraqes',
    'Chat': 'Chat',
    'win_multiplier': 'FITO MULTIPLIER',
    'win_amount': 'FITO SHUM',
    'first_color': 'NGJYRA E PAR',
    'sure2share': 'A jeni i sigurt se doni të ndani?',
    'Share': 'Pjesë',
    'chat_message': 'Chat mesazh',
    'yes': 'Po',
    'no': 'Jo',
    'welcome': 'I mirëpritur',
    'credit_balance': 'Gjendja e kreditit: ',
    'last_color': 'Ngjyra e fundit',
    'last_ball_parity': 'Topi i fundit  Çift/Tek',
    'ticket_amount_less': 'Shuma e tiketën mund të mos jetë më e vogël se ',
    'ticket_amount_more': 'Shuma e tiketën nuk mund të jetë më e madhe se  '
};

langArr['es'] = {
    'odds': 'Cuotas',
    'popular': 'Popular',
    'standings': 'Posiciones',
    'final_score': 'RESULTADO FINAL',
    'home_goals': 'GOL EQUIPO LOCAL',
    'away_goals': 'GOL EQUIPO DE FUERA',
    'score': 'ANOTAR',
    'last_results': 'Últimos resultados',
    'live_score': 'DIRECTO',
    'teams': 'EQUIPOS',
    'team': 'EQUIPO',
    'pts': 'Pts',
    'pos': 'POS',
    'please_login': 'Por favor Iniciar sesión ',
    'minimum_stake_is': 'La apuesta mínima es',
    'maximum_stake_is': 'La apuesta máxima es',
    'you_dont_have_enough_deposit': 'No tienes suficiente deposito',
    'unknown_session_id': 'Unknown SessionID',
    'betting': 'Apuesta',
    'statistics': 'Estadística',
    'tickets': 'Boletos',
    'amount': 'suma',
    'no_of_rounds': 'Num. de rondas',
    'repeat_last': 'Repetir la última',
    'random_six': 'Seis al azar',
    'random': 'Aleatoria',
    'random_one': 'Aleatoria',
    'all_colors': 'Todos los colores',
    'hot_six': 'Hot Six',
    'cold_six': 'Cold Six',
    'buy_ticket': 'Comprar boleto',
    'chosen_ticket_combination': 'Combinación de boleto elegido',
    'all_of_the_balls': 'Todas las bolas',
    'more_odd': 'Más impar',
    'more_even': 'Más par',
    'less': 'Menos',
    'more': 'Más',
    'even': 'Par',
    'odd': 'Impar',
    'first_five_balls': 'Primeras 5 bolas',
    'first_ball': 'Primera bola',
    'last_ball': 'Ultima bola',
    'top_color': 'Color más común',
    'red': 'Rojo',
    'green': 'Verde',
    'blue': 'Azul',
    'purple': 'Púrpura',
    'brown': 'Marrón',
    'yellow': 'Amarillo',
    'orange': 'Naranja',
    'black': 'Negro',
    'silver': 'Negro',
    'the_most_common_numbers': 'Los numeros más comunes',
    'the_rarest_numbers': 'Los numeros menos comunes',
    'ticket_id': 'Boleto ID',
    'all': 'todas las bolas',
    'common_color': 'Color más común',
    'parity': 'Par/Impar',
    'round_no': 'Ronda núm',
    'jackpot_code': 'Código de Jackpot',
    'purchased_a_ticket': 'Ha comprado un boleto exitosamente',
    'chose_some_bets': 'Por favor, elija algunas apuestas para comprar el boleto',
    'winner': 'Ganador',
    'w': 'V',
    'l': 'D',
    'FORM': 'Forma',
    'place': 'Lugar',
    'show': 'Mostrar',
    'second': 'Segundo',
    'third': 'Tercero',
    'trifecta': 'Trifecta',
    'perfecta': 'Perfecta',
    'double_chance': 'Doble oportunidad',
    'low': 'Menos',
    'high': 'Más',
    'sum': 'Suma',
    'jackpot': 'JACKPOT',
    'race': 'CARRERA',
    'mega_jackpot': 'Mega Jackpot',
    'regional_jackpot': 'Regional Jackpot',
    'weldmag_regional_jackpot': 'SUPERBONUS',
    'weldmag_jackpot':'WELDPOT',
    'number_of_goals': 'NÚMERO DE GOLES',
    'result': 'RESULTADO',
    'total_goals': 'total de goles',
    'correct_score': 'RESULTADO EXACTO',
    'ht': 'MT',
    'ft': 'TC',
    'ht_ft': 'MEDIO TIEMPO / TIEMPO COMPLETO',
    'next': 'SIGUIENTE',
    'half_time_full_time': 'MEDIO TIEMPO / TIEMPO COMPLETO',
    'over_under': 'Menos de/Más que',
    'full_time_goals_combination': 'RESULTADO FINAL/ GOLES',
    'gg_ng': 'GG / NG',
    'double_chance_gg_ng': 'Doble oportunidad + GG / NG',
    'home': 'LOCAL',
    'away': 'VISITA.',
    'general_statistics': 'Estadísticas Generales',
    'odd_even': 'IMP/PAR',
    'odd_even_home': 'IMPAR / PAR LOCAL',
    'odd_even_away': ' IMPAR / PAR VISITANTE',
    'home_score': 'RESULTADO LOCAL',
    'away_score': 'RESULTADO VISITANTE',
    'home_ou': 'LOCAL O/U',
    'away_ou': 'VISITANTE O/U',
    'uo15_1x2': 'UO15 + 1X2',
    'uo25_1x2': 'UO25 + 1X2',
    'gg_ng_over_under': 'GG / NG OVER UNDER',
    'first_half': ' PRIMERA MITAD',
    'slip': 'TALÓN',
    'bet_slip': 'TALÓN DE APUESTA',
    'combinations': 'Combinaciones',
    'system': 'Sistema',
    'total_odd': 'Total impar',
    'total_stake': 'Stake total',
    'potential_maximal_win': 'Potencial de ganancia máxima',
    'place_bet': 'Pagar apuestas',
    'favorites': 'Favoritos',
    'underdogs': 'Underdogs',
    'please_choose': 'Por favor, elija algunas apuestas primero',
    'open': 'ABRIR',
    'chose_valid_amount': 'Por favor seleccione la cantidad de apuesta válida ',
    'no_tickets_for_current_game': 'No hay boletos para el juego actual.',
    'game': 'Juego',
    'apple_video_no_support': 'Su dispositivo Apple no admite la transmisión de video, actualice a iOS 10+ para ver videos de carreras.',
    'color': 'Color',
    'error_purchasing_ticket': 'Error al comprar el ticket',
    'choose_1_2_4_common': 'Por favor, elija 1,2 o 4 colores para el color más común',
    'choose_1_2_4_first': 'Por favor, elige 1,2 o 4 colores para la primera bola',
    'choose_1_2_4_last': 'Por favor, elige 1,2 o 4 colores para la última bola',
    'confirm_buying': 'Confirmar',
    'cancel_buying': 'Cancelar',
    'buying_title': '¿Está seguro de que quiere comprar el boleto?',
    'please_wait': 'Por favor espere...',
    'tutorial_close': 'CERRAR',
    'tutorial_next': 'SIGUIENTE',
    'tutorial_back': 'ATRÁS',
    'tutorial_1': 'Este rápido tutorial le explicará cómo hacer una apuesta en "Lucky Balls"',
    'tutorial_2': 'Aquí puedes elegir tus números. Elige de 6 a 10 números',
    'tutorial_3': 'Puede elegir apuestas como par / impar, color superior, etc. haciendo clic en los botones y / o colores de una apuesta.',
    'tutorial_4': 'Elija el monto de una apuesta: mínimo, máximo, tres valores presentados o ingrese un monto personalizado.',
    'tutorial_5': 'Elija una serie de rondas de juego',
    'tutorial_6': 'Al hacer clic en "Comprar boleto" se aceptará su apuesta..',
    'tutorial_7': 'En esta parte de la pantalla puede monitorear sus boletos durante la ronda. Los números pintados y las apuestas ganadoras se marcarán en diferentes colores. El titúlo de los boletos ganadoras se marcará en verde.',
    'tutorial_8': 'Puedes seguir como se sacan las bolas en esta parte de la pantalla, como si estuvieras en una tienda de apuestas deportivas.',
    'tutorial_9': 'Varias estadísticas pueden ayudarle a hacer su combinación ganadora.',
    'help': 'Ayuda',
    'tickets-vfl': 'Boletos / Estadísticas',
    'results': 'RESULTADOS',
    'for_draw': 'Sacar',
    'draw': 'SR',
    'd': 'E',
    'results_lower': 'Resultados',
    'round_completed': 'RONDA COMPLETA',
    'first_5_no_award': 'PRIMERAS 5 BOLAS SIN PREMIO',
    'last_bets': 'Últimas apuestas por favor!',
    'color_betting': 'Apuestas de color',
    'preballs_sum': 'Los primeros cinco',
    'bonus_numbers': 'Extra numeros',
    'current_round': 'Ronda actual',
    'rounds_total': 'rondas totales',
    'value': 'Value',
    'quick_lucky_ball': 'Quick Lucky Ball',
    'Login': 'Iniciar sesión',
    'Logout': 'Cerrar sesión',
    'login_credentials': 'Credenciales de acceso',
    'Username': 'Nombre de usuario',
    'Password': 'Contraseña',
    'request_payout': 'Solicitud de pago',
    'payout_pin': 'PIN de pago',
    'Ok': 'Ok',
    'auth_failed': 'Error: error de autenticación',
    'enter_alias': 'Ingresar alias',
    'Submit': 'Enviar',
    'Chat': 'Chat',
    'win_multiplier': 'GANAR MULTIPLICADOR',
    'win_amount': 'GANAR CANTIDAD',
    'first_color': 'PRIMER COLOR',
    'sure2share': 'Estás seguro de que quieres compartir?',
    'Share': 'Compartir',
    'chat_message': 'Mensaje de chat',
    'yes': 'Si',
    'no': 'No',
    'welcome': 'Bienvenidos',
    'credit_balance': 'Balance de crédito : ',
    'last_color': 'Último color',
    'last_ball_parity': 'Ultima bola par/impar',
    'ticket_amount_less': 'El monto del boleto no puede ser inferior a  ',
    'ticket_amount_more': 'El monto del boleto no puede ser mayor que '
};

langArr['fr'] = {
    'odds': 'Quotas',
    'popular': 'POPULAIRE',
    'standings': 'Classement',
    'final_score': 'SCORE FINAL',
    'home_goals': 'GOL ÉQUIPE À DOMICILE FINAL',
    'away_goals': 'GOL ÉQUIPE EXTÉRIEURE',
    'score': 'MARQUER',
    'last_results': 'Derniers résultats',
    'live_score': 'EN DIRECT',
    'teams': 'ÉQUIPES',
    'team': 'CLUB',
    'pts': 'PTS',
    'pos': 'POS',
    'please_login': "S 'il vous plaît login",
    'minimum_stake_is': 'La mise minimale est',
    'maximum_stake_is': 'La mise maximale est',
    'you_dont_have_enough_deposit': "Vous n'avez pas assez de caution",
    'unknown_session_id': 'Unknown SessionID',
    'betting': 'Le pari',
    'statistics': 'Statistique',
    'tickets': 'Billet',
    'amount': 'Somme',
    'no_of_rounds': 'No Des Tours',
    'repeat_last': 'Répéter Le Dernier',
    'random_six': 'Six Aléatoires',
    'random': 'Aléatoires',
    'random_one': 'Aléatoires',
    'all_colors': 'Toutes Les Couleurs',
    'hot_six': 'Hot Six',
    'cold_six': 'Cold Six',
    'buy_ticket': 'Acheter Le Billet',
    'chosen_ticket_combination': 'Combinaison Du Billet Choisie',
    'all_of_the_balls': 'Toutes Les Balles',
    'more_odd': 'Plus Des Imp.',
    'more_even': 'Plus Des Pair.',
    'less': 'Moins',
    'more': 'Plus',
    'even': 'Pair',
    'odd': 'Impair',
    'first_five_balls': 'Cinque Premières Balles',
    'first_ball': 'Première Balle',
    'last_ball': ' Dernière Balle ',
    'top_color': 'La Couleur La Plus Fréquente',
    'red': 'Rouge',
    'green': 'Vert',
    'blue': 'Bleu',
    'purple': 'Violet',
    'brown': 'Maron',
    'yellow': 'Jaune',
    'orange': 'Orange',
    'black': 'Noir',
    'silver': 'Noir',
    'the_most_common_numbers': 'Les numéros les plus fréquents',
    'the_rarest_numbers': 'Les numéros les plus rares',
    'ticket_id': 'Numéro De Billet',
    'all': 'Toutes Les Balles',
    'common_color': 'La Couleur Fréquente',
    'parity': 'Parité',
    'round_no': 'Numéro De Tour',
    'jackpot_code': 'Code Jackpot',
    'purchased_a_ticket': 'Vous avez acheté le billet avec succès',
    'chose_some_bets': 'S’il vous plaît, choisissez un pari pour acheter le billet',
    'winner': 'Gagnant',
    'w': 'G',
    'l': 'P',
    'FORM': 'PRÉC',
    'place': 'En deux premiers',
    'show': ' En trois premiers ',
    'second': 'Deuxième place',
    'third': 'Troisième place',
    'trifecta': 'Trifecta',
    'perfecta': 'Perfecta',
    'double_chance': 'Chance Double',
    'low': 'Moins',
    'high': 'Plus',
    'sum': 'Somme',
    'jackpot': 'GROS LOT',
    'race': 'COURSE',
    'mega_jackpot': 'Méga Gros Lot',
    'number_of_goals': 'NOMBRE DES BUTS',
    'result': 'RÉSULTAT',
    'total_goals': 'LE TOTAL DES BUTS',
    'correct_score': 'LE RÉSULTAT CORRECT',
    'ht': 'HT',
    'ft': 'FT',
    'ht_ft': 'HT/FT',
    'next': 'SUIVANT',
    'half_time_full_time': 'MI-TEMPS / LA FIN',
    'over_under': 'PLUS MOINS',
    'full_time_goals_combination': 'LA FIN / COMBINAISON DES BUTS',
    'gg_ng': 'GG / NG',
    'double_chance_gg_ng': 'CHANCE DOUBLE + GG / NG',
    'home': 'DOMIC.',
    'away': 'L’EXTÉR.',
    'general_statistics': 'Statistique Générale',
    'odd_even': 'IMP./PAIR',
    'odd_even_home': 'IMPAIR / PAIR  DOMICILE',
    'odd_even_away': 'IMPAIR / PAIR  L’EXTÉRIEUR',
    'home_score': 'LE RÉSULTAT À DOMICILE',
    'away_score': 'LE RÉSULTAT À L’EXTÉRIEUR',
    'home_ou': 'DOMICILE PLUS MOINS',
    'away_ou': ' L’EXTÉRIEUR PLUS MOINS',
    'uo15_1x2': 'UO15 + 1X2',
    'uo25_1x2': 'UO25 + 1X2',
    'gg_ng_over_under': 'GG / NG PLUS MOINS BUTS',
    'first_half': 'LE MI-TEMPS PREMIÈRE',
    'slip': 'Billet',
    'bet_slip': 'BILLET',
    'combinations': 'Combinaisons',
    'system': 'Méthode',
    'total_odd': 'Cote Totale',
    'total_stake': 'Participation Totale',
    'potential_maximal_win': 'Gain Potentiel Maximum',
    'place_bet': 'Placer les paris',
    'favorites': 'Les Favorites',
    'underdogs': 'Les Perdants Probables',
    'please_choose': 'S’il vous plait, choisissez quelques paris',
    'open': 'OUVERT',
    'chose_valid_amount': 'S’il vous plait, sélectionnez une somme valide pour le pari des',
    'no_tickets_for_current_game': 'Il n’y a pas des billets pour la partie présente',
    'game': 'Partie',
    'apple_video_no_support': 'Votre appareil Apple ne supporte pas le streaming vidéo, s’il vous plait, actualisez iOS 10+ pour regarder les vidéos. ',
    'color': 'Couleur',
    'error_purchasing_ticket': 'Erreur en achat de billet',
    'choose_1_2_4_common': 'S’il vous plait, choisissez une, deux ou quatre couleurs pour la couleur la plus fréquente.',
    'choose_1_2_4_first': 'S’il vous plait, choisissez une, deux ou quatre couleurs pour la balle première.',
    'choose_1_2_4_last': 'S’il vous plait, choisissez une, deux ou quatre couleurs pour la balle dernière',
    'confirm_buying': 'OK',
    'cancel_buying': 'Annulez',
    'buying_title': 'Êtes-vous sûr que vous voulez acheter le billet?',
    'please_wait': 'Attendez s’il vous plait…',
    'tutorial_close': 'FERMEZ',
    'tutorial_next': 'SUIVANT',
    'tutorial_back': 'RETOURNEZ',
    'tutorial_1': 'Ce tutoriel court expliquera comment vous pouvez placer un pari sur ‘’Lucky Balls’’;',
    'tutorial_2': ' Ici vous pouvez choisir vos numéros. Choisissez entre 6 et 10 numéros.',
    'tutorial_3': 'Vous pouvez choisir les paris (pair/impair, la couleur la plus fréquente etc.) en cliquant sur les boutons et/ou les couleurs du pari',
    'tutorial_4': 'Choisissez la somme d’un pari : minimum, maximum, trois valeurs présentées ou entrez une somme customisée.',
    'tutorial_5': 'Choisissez le nombre des tours.',
    'tutorial_6': 'En cliquant sur ‘’Achetez le billet’’ votre pari sera accepté.',
    'tutorial_7': 'Dans cette partie-ci d’écran vous pouvez surveiller vos billets pendant le tour. Les numéros tirés et les paris gagnants seront marqués en autres couleurs. Les en-têtes des billets gagnants seront marqués en couleur verte.',
    'tutorial_8': ' Vous pouvez regarder le tirage de balles dans cette partie-ci d’écran.',
    'tutorial_9': ' La statistique varié peut vous aider à faire votre combinaison gagnante. Aide ',
    'tickets-vfl': 'Billets/Statistiques',
    'help': 'Aide',
    'results': ' RÉSULTATS ',
    'for_draw': 'Pour Tirer',
    'draw': 'N rés.',
    'd': 'D',
    'results_lower': 'Résultats',
    'round_completed': 'TOUR COMPLETÉ',
    'first_5_no_award': 'LES 5 PREMIÈRES BALLES SANS TROPHÉE',
    'last_bets': ' Derniers paris s’il vous plait!',
    'color_betting': 'Les paris sur les couleurs',
    'preballs_sum': 'Les cinq premiers',
    'bonus_numbers': 'Les num. addition.',
    'current_round': 'Tours actuel',
    'rounds_total': 'Tours totals',
    'value': 'Value',
    'quick_lucky_ball': 'Quick Lucky Ball',
    'Login': "S'identifier",
    'Logout': "Se déconnecter",
    'login_credentials': "Identifiants de connexion",
    'Username': "Nom d'utilisateur",
    'Password': "Mot de passe",
    'request_payout': "Demande paiement",
    'payout_pin': "PIN de paiement",
    'Ok': "Ok",
    'auth_failed': "Erreur: L'authentification a échoué",
    'enter_alias': "Entrez un alias",
    'Submit': "Soumettre",
    'Chat': "Chat",
    'win_multiplier': "GAGNEZ MULTIPLICATEUR",
    'win_amount': "GAGNEZ LE MONTANT",
    'first_color': "PREMIÈRE COULEUR",
    'sure2share': "Êtes-vous sûr de vouloir partager?",
    'Share': "Partager",
    'chat_message': "Message de chat",
    'yes': 'Oui',
    'no': 'Non',
    'welcome': 'Nous saluons le retour',
    'credit_balance': 'Solde créditeur : ',
    'last_color': 'Dernière couleur',
    'last_ball_parity': 'Dernière Balle Pair/Impair',
    'ticket_amount_less': 'Le montant du billet ne peut être inférieur à ',
    'ticket_amount_more': 'Le montant du billet ne peut être supérieur à '
};

langArr['it'] = {
    'odds': 'Quote',
    'popular': 'POPOLARE',
    'standings': 'Classifica',
    'final_score': 'RESULTATO FINALE',
    'home_goals': 'GOAL SQUADRA DI CASA',
    'away_goals': 'GOAL SQUADRA OSPITE',
    'score': 'SEGNA',
    'last_results': 'ULTIMI RISULTATI',
    'live_score': 'LIVEBETTING',
    'teams': 'SQUADRE',
    'team': 'SQUADRA',
    'pts': 'Pun',
    'pos': 'POS',
    'please_login': 'Effettuare il login prego',
    'minimum_stake_is': 'La puntata minima è',
    'maximum_stake_is': 'La puntata massima è',
    'you_dont_have_enough_deposit': 'Non hai deposito sufficiente',
    'unknown_session_id': 'Unknown SessionID',
    'betting': 'Scommesse',
    'statistics': 'Statistica',
    'tickets': 'I ticket',
    'amount': 'Importo',
    'no_of_rounds': 'Numero dell’estrazione',
    'repeat_last': 'Ripeti l’ultima scommessa',
    'random_six': '6 casuali',
    'random': 'Numeri casuali',
    'random_one': 'Numero casuale',
    'all_colors': 'Tutti I colori',
    'hot_six': 'Hot Six',
    'cold_six': 'Cold Six',
    'buy_ticket': 'Gioca il ticket',
    'chosen_ticket_combination': 'La combinazione scelta',
    'all_of_the_balls': 'Tutte le palline',
    'more_odd': 'Piu’ dispari',
    'more_even': 'Piu’ pari',
    'less': 'Under',
    'more': 'Over',
    'even': 'Pari',
    'odd': 'Dispari',
    'first_five_balls': 'Le prime 5 palline',
    'first_ball': 'La prima pallina',
    'last_ball': 'L’ultima pallina',
    'top_color': 'Il colore piu’ frequente',
    'red': 'Rosso',
    'green': 'Verde',
    'blue': 'Blu',
    'purple': 'Viola',
    'brown': 'Marrone',
    'yellow': 'Giallo',
    'orange': 'Arancione',
    'black': 'Nero',
    'silver': 'Nero',
    'the_most_common_numbers': 'I numeri piu’ frequenti',
    'the_rarest_numbers': 'I numeri meno frequenti',
    'ticket_id': 'Id del ticket',
    'all': 'Tutte le palline',
    'common_color': 'Il colore piu’ frequente',
    'parity': 'Pari/Dispari',
    'round_no': 'Numero del gioco',
    'jackpot_code': 'Codice Jackpot',
    'purchased_a_ticket': 'La scommessa piazzata con successo!',
    'chose_some_bets': 'Scegliere le scommesse per poter puntare!',
    'winner': 'Il vincitore',
    'w': 'V',
    'l': 'S',
    'FORM': 'Forma',
    'place': 'Tra i primi due',
    'show': 'Tra I primi 3',
    'second': 'Il secondo posto',
    'third': 'Il terzo posto',
    'trifecta': 'Trifecta',
    'perfecta': 'Perfecta',
    'double_chance': 'Doppia chance',
    'low': 'Minore',
    'high': 'Maggiore',
    'sum': 'Somma',
    'jackpot': 'JACKPOT',
    'race': 'GARA',
    'mega_jackpot': 'Mega Jackpot',
    'regional_jackpot': 'Jackpot Regionale',
    'weldmag_regional_jackpot': 'SUPERBONUS',
    'weldmag_jackpot':'WELDPOT',
    'number_of_goals': 'NUMERO GOAL',
    'result': 'RISULTATO',
    'total_goals': 'SOMMA DEI GOAL',
    'correct_score': 'RISULTATO ESATTO',
    'ht': 'PA',
    'ft': 'FI',
    'ht_ft': 'PARZIALE-FINALE',
    'next': 'LA PROSSIMA',
    'half_time_full_time': 'PARZIALE-FINALE',
    'over_under': 'OVER/UNDER',
    'full_time_goals_combination': 'COMBINAZIONE ESITO/GOAL ',
    'gg_ng': 'GG / NG',
    'double_chance_gg_ng': 'DOPPIA CHANCE + GG / NG',
    'home': 'CASA',
    'away': 'OSPITE',
    'general_statistics': 'Statistica Generale',
    'odd_even': 'DISP./PARI',
    'odd_even_home': 'DISPARI/PARI CASA',
    'odd_even_away': 'DISPARI/PARI OSPITE',
    'home_score': 'GOAL CASA',
    'away_score': 'GOAL OSPITE',
    'home_ou': 'CASA O/U',
    'away_ou': 'OSPITE O/U',
    'uo15_1x2': 'U/O15 + 1X2',
    'uo25_1x2': 'U/O25 + 1X2',
    'gg_ng_over_under': 'GG / NG + O/U',
    'first_half': 'PRIMO TEMPO',
    'slip': 'Ticket',
    'bet_slip': 'listino scommessa',
    'combinations': 'Combinazione',
    'system': 'Sistema',
    'total_odd': 'Quota totale',
    'total_stake': 'Importo giocato',
    'potential_maximal_win': 'La vincita potenziale',
    'place_bet': 'Piazzare la scommessa',
    'favorites': 'I favoriti',
    'underdogs': 'I sfavoriti',
    'please_choose': 'Scegliere le scommesse per poter puntare!',
    'open': 'APERTO',
    'chose_valid_amount': 'Scegliere l’importo valido',
    'no_tickets_for_current_game': 'Non ci sono I ticket per il gioco attuale',
    'game': 'Gioco',
    'apple_video_no_support': 'l tuo dispositivo Apple non supporta il video streaming, eseguire l upgrade a iOS 10+ per guardare i video delle gare.',
    'color': 'Colore',
    'error_purchasing_ticket': 'Errore durante il piazzamento della scommessa.',
    'choose_1_2_4_common': 'Scegliere uno, due o quattro colori come colori piu frequenti',
    'choose_1_2_4_first': 'Scegliere uno, due o quattro colori come il colore della prima pallina',
    'choose_1_2_4_last': ' Scegliere uno, due o quattro colori come colore dell’ultima pallina',
    'confirm_buying': 'Conferma',
    'cancel_buying': 'Cancella',
    'buying_title': 'Conferma il piazzamento della scommessa?',
    'please_wait': 'La preghiamo di attendere...',
    'tutorial_close': 'CHIUDERE',
    'tutorial_next': 'SUCCESSIVO',
    'tutorial_back': 'INDIETRO',
    'tutorial_1': 'Questo breve tutorial ti spiegherà come piazzare una scommessa su "Lucky Balls"',
    'tutorial_2': 'Qua puo’ selezionare  i numeri. Scelga da 6 a 10 numeri',
    'tutorial_3': 'Puo scegliere scommesse come pari/dispari, colore piu frequente ecc. cliccando su pulsanti e/o colori della puntata',
    'tutorial_4': 'Scelga l importo della scommessa: minimo, massimo, tre valori proposti o inserisca l importo desiderato',
    'tutorial_5': 'Scegliere il numero di round di gioco',
    'tutorial_6': 'Cliccando su ‘’Piazzare la scommessa’’ la Sua scommessa sara’ accettata',
    'tutorial_7': 'In questa parte della schermata è possibile seguire lo stato delle scommesse durante il round. I numeri estratti e le scommesse vincenti saranno distinti da colori diversi.La parte superiore di una scommessa vincente sarà contrassegnata in verde. ',
    'tutorial_8': 'L’estrazione delle palline e’ possibile seguire in questa parte dello schermo.',
    'tutorial_9': 'Le varie statistiche possono essere d’aiuto per piazzare la Sua combinazione vincente',
    'help': 'Aiuto',
    'tickets-vfl': 'I ticket/statistiche.',
    'results': 'RISULTATI',
    'for_draw': 'Per l’estrazione',
    'draw': 'Disegnare',
    'd': 'N',
    'results_lower': 'Risultati',
    'round_completed': 'Il gioco e’ terminato',
    'first_5_no_award': 'LE PRIME 5 PALLINE',
    'last_bets': 'Ultime puntate!',
    'color_betting': 'Scommesse sui colori',
    'preballs_sum': 'Primi 5',
    'bonus_numbers': 'Numeri Bonus',
    'current_round': 'L’estrazione attuale',
    'rounds_total': 'Numero totale delle estrazioni',
    'value': 'Value',
    'quick_lucky_ball': 'Quick Lucky Ball',
    'Login': 'Login',
    'Logout': 'Esci',
    'login_credentials': "Credenziali d'accesso",
    'Username': 'Nome utente',
    'Password': 'Password',
    'request_payout': 'Richiesta di prelievo',
    'payout_pin': 'PIN di prelievo',
    'Ok': 'Ok',
    'auth_failed': 'Errore: Autenticazione fallita',
    'enter_alias': 'Inserire alias',
    'Submit': 'Sottoporre',
    'Chat': 'Chat',
    'win_multiplier': 'VINCI MULTIPLICATORE',
    'win_amount': 'VINCI IMPORTO',
    'first_color': 'IL PRIMO COLORE',
    'sure2share': 'Sicuro di voler condividere?',
    'Share': 'Condividi',
    'chat_message': 'Messaggio chat',
    'yes': 'Sì',
    'no': 'No',
    'welcome': 'Ben tornat',
    'credit_balance': 'Saldo del credito: ',
    'last_color': 'Ultimo colore',
    'last_ball_parity': 'L’ultima pallina Pari/Dispari',
    'ticket_amount_less': "L'importo del biglietto non può essere inferiore a ",
    'ticket_amount_more': "L'importo del biglietto non può essere maggiore di "
};

langArr['ro'] = {
    'odds': 'Cote',
    "popular": "Popular",
    "standings": "Clasament",
    "final_score": "Scor Final",
    "home_goals": "Goluri Ech. Gazda",
    "away_goals": "Goluri Ech. Oaspete",
    "score": "Marcheaza",
    "last_results": "Ultimele rezultate",
    "live_score": "Livescore",
    "teams": "Echipele",
    "team": "Echipa",
    "pts": "Puncte",
    "pos": "POZ",
    "please_login": "Va rugam sa va logati ",
    "minimum_stake_is": "Miza minima este:",
    "maximum_stake_is": "Miza maxima este:",
    "you_dont_have_enough_deposit": "Nu aveți suficient depozit",
    "unknown_session_id": "Unknown SessionID",
    "betting": "Pariuri",
    "statistics": "Statistici",
    "tickets": "Bilete",
    "amount": "Suma",
    "no_of_rounds": "Nr. de runde ",
    "repeat_last": "Repeta pariu",
    "random_six": "6 aleatoare",
    "random": "Aleatoare",
    "random_one": "Aleatoare",
    "all_colors": "Toate Culorile",
    "hot_six": "Hot 6",
    "cold_six": "Cold 6",
    "buy_ticket": "Pariaza acum",
    "chosen_ticket_combination": "Combinatie aleasa",
    "all_of_the_balls": "Toate bilele",
    "more_odd": "Mai multe imp",
    "more_even": "Mai multe par",
    "less": "Sub",
    "more": "Peste",
    "even": "Par",
    "odd": "Impar",
    "first_five_balls": "Primele 5 bile",
    "first_ball": "Prima bila",
    "last_ball": "Ultima bila",
    "top_color": "Cea mai frecventa culoare",
    "red": "Rosu",
    "green": "Verde",
    "blue": "Albastru",
    "purple": "Violet",
    "brown": "Maro",
    "yellow": "Galben",
    "orange": "Portocaliu",
    "black": "Negru",
    "silver": "Argintiu",
    "the_most_common_numbers": "Cele mai frecvente numere",
    "the_rarest_numbers": "Cele mai rare numere",
    "ticket_id": "Seria biletului",
    "all": "Toate bilele",
    "common_color": "Mai frecv.cul",
    "parity": "Par/Impar",
    "round_no": "Runda nr.",
    "jackpot_code": "Extra Premiu Cod",
    "purchased_a_ticket": "Bilet achitat cu succes!",
    "chose_some_bets": "Va rugam sa alegeti un pariu",
    "winner": "Castigator",
    "w": "V",
    "l": "Î",
    "FORM ": "Forma",
    "place": "In primii doi",
    "show": "In primii trei",
    "second": "Locul al doilea",
    "third": "Locul al treilea",
    "trifecta": "Trifecta",
    "perfecta": "Perfecta",
    "double_chance": "Sansa dubla",
    "low": "Mai putin",
    "high": "M.mult",
    "sum": "Suma",
    "jackpot": "Extra Premiu",
    "race": "Cursa",
    "mega_jackpot": "Mega Extra Premiu",
    "number_of_goals": "Numar de goluri",
    "result": "Rezultat",
    "total_goals": "Total goluri",
    "correct_score": "Scor corect",
    "ht": "Prima repriza",
    "ft": "Final",
    "ht_ft": "Prima repriza / Final",
    "next": "Urmatorul",
    "half_time_full_time": "Prima repriza / Final",
    "over_under": "Goluri",
    "full_time_goals_combination": "Rezultatul final / goluri",
    "gg_ng": "GG / NG",
    "double_chance_gg_ng": "Sansa dubla + GG / NG",
    "home": "Gazde",
    "away": "Oaspeti",
    "general_statistics": "Statistica generala",
    "odd_even": "Imp/Par",
    "odd_even_home": "Impar / Par gazda",
    "odd_even_away": "Impar / Par oaspete",
    "home_score": "Goluri Gazde",
    "away_score": "Goluri Oaspete",
    "home_ou": "Gazda Goluri",
    "away_ou": "Oaspete Goluri",
    "uo15_1x2": "UO15 + 1X2",
    "uo25_1x2": "UO25 + 1X2",
    "gg_ng_over_under": "GG / NG goluri",
    "first_half": "Prima repriza",
    "slip": "Bilet",
    "bet_slip": "Bilet",
    "combinations": "Combinatii",
    "system": "Sistem",
    "total_odd": "Cota totala",
    "total_stake": "Miza totala",
    "potential_maximal_win": "Castig eventual",
    "place_bet": "Plateste biletul",
    "favorites": "Favoriti",
    "underdogs": "Outsideri",
    "please_choose": "Selectati un pariu ca sa achitati biletul!",
    "open": "Deschis",
    "chose_valid_amount": "Selectati o miza valida",
    "no_tickets_for_current_game": "Nu sunt bilete pentru jocul curent ",
    "game": "Joc",
    "apple_video_no_support": "Dispozitivul Dvs. Apple nu are suport pentru streaming video, actualizati software-ul la iOS10 pentru a putea viziona",
    "color": "Culoare",
    "error_purchasing_ticket": "Biletul nu a fost creat",
    "choose_1_2_4_common": "Selectati una, doua sau patru culori pentru culoarea cea mai frecventa",
    "choose_1_2_4_first": "Selectati una, doua sau patru culori pentru prima bila",
    "choose_1_2_4_last": "Selectati una, doua sau patru culori pentru ultima bila",
    "confirm_buying": "Confirmati",
    "cancel_buying": "Renuntati",
    "buying_title": "Sunteti sigur ca doriti sa achitati biletul?",
    "please_wait": "Va rugam sa asteptati...",
    "tutorial_close": "Inchideti",
    "tutorial_next": "Urmatorul",
    "tutorial_back": "Inapoi",
    "tutorial_1": "Aceasta scurta instructiune va va arata cum sa introduceti un pariu pe jocul ",
    "tutorial_2": "Aici puteti selecta numerele Dvs. Alegeti 6 din 10 numere.",
    "tutorial_3": "Pariuri pe mize externe ( par/impar; cea mai frecventa culoare; etc.) selectati facand click pe buton si/sau culorile pariurilor externe.",
    "tutorial_4": "Selectati miza",
    "tutorial_5": "Selectati numarul de runde pentru joc în prealabil.",
    "tutorial_6": "Facand click pe ",
    "tutorial_7": "Aici puteti urmari statul biletului Dvs. pe parcursul extragerii. Numerele extrase si pariuri externe câstigatoare vor fi special indicate cu o alta culoare. Antentul biletelor câstigatoare este indicat cu culoarea verde.",
    "tutorial_8": "Extragerea bilelor o puteti urmari in aceasta parte a ecranului ca si cand v-ati fi aflat intr-o de sala de pariuri sportive.",
    "tutorial_9": "Diferite statistici va pot ajuta sa alegeti combinatia Dvs. castigatoare.",
    "help": "Ajutor",
    "tickets-vfl": "Bilet-vfl",
    "results": "Rezultate",
    "for_draw": "Pentru extragere",
    "draw": "Extragere",
    "d": "E",
    "results_lower": "Rezultate",
    "round_completed": "Runda terminata",
    "first_5_no_award": "Primele 5 bile",
    "last_bets": "Ultimele pariuri!",
    "color_betting": "Pariuri pe culoare",
    "preballs_sum": "Primele 5 bile",
    "bonus_numbers": "Numere bonus",
    "current_round": "Runda actuala",
    "rounds_total": "Total runde",
    "value": "Valoare",
    "quick_lucky_ball ": "Quick Lucky Ball",
    "Login": "Autentificare",
    "Logout": "Deconectare",
    "login_credentials ": "Date de conectare",
    "Username": "Nume de utilizator",
    "Password": "Parola",
    "request_payout": "Solicitați plata",
    "payout_pin": "PIN pentru plata",
    "Ok": "Ok",
    "auth_failed": "Eroare:  Autentificarea a esuat",
    "enter_alias": "Introduceți alias",
    "Submit": "Trimite",
    "Chat": "Chat",
    "win_multiplier": "Castig multiplicat",
    "win_amount": "Castig",
    "first_color": "Prima culoare",
    "sure2share": "Ești sigur că vrei să împărtășești?",
    "Share": "Actiune",
    "chat_message": "Chat",
    "yes": "Da",
    "no": "Nu",
    "welcome": "Bine ati venit",
    "credit_balance": "Balanta soldului",
    "last_color": "Ultima culoare",
    "last_ball_parity": "Ultima bila Par/Impar",
    "ticket_amount_less": "Miza pe bilet nu poate fi mai mica de ",
    "ticket_amount_more": "Miza pe bilet nu poate fi mai mare de ",
    "betting_info": " in intervalul 9:00 - 24:00"
};

langArr['ru'] = {
    'odds': 'Квоты',
    'popular': 'ПОПУЛЯРНЫЙ',
    'standings': 'Турнирная таблица',
    'final_score': 'ФИНАЛЬНЫЙ РЕЗУЛЬТАТ',
    'home_goals': 'ГОЛ ДОМАШНЯЯ КОМАНДА',
    'away_goals': 'ГОЛ ГОСТИНАЯ КОМАНДА',
    'score': 'Забьют',
    'last_results': 'Последние результаты',
    'live_score': 'Live Score',
    'teams': 'КОМАНДЫ',
    'team': 'КОМАНДА',
    'pts': 'Очк',
    'pos': 'ПОЗ',
    'please_login': 'Пожалуйста, войдите',
    'minimum_stake_is': 'Максимальная ставка',
    'maximum_stake_is': 'Минимальная ставка',
    'you_dont_have_enough_deposit': 'У вас недостаточно депозита',
    'unknown_session_id': 'Unknown SessionID',
    'betting': 'Сделать ставку',
    'statistics': 'Статистика',
    'tickets': 'Купоны',
    'amount': 'Сумма',
    'no_of_rounds': 'Кол. Кругов',
    'repeat_last': 'Повторить Последнее',
    'random_six': 'Случайные Шесть',
    'random': 'Cлучайный',
    'random_one': 'Cлучайный',
    'all_colors': 'Все Цвета',
    'hot_six': 'Hot Six',
    'cold_six': 'Cold Six',
    'buy_ticket': 'Оплатить Купон',
    'chosen_ticket_combination': 'Выбранная Комбинация',
    'all_of_the_balls': 'Все Шары',
    'more_odd': 'Больше Неч.',
    'more_even': 'Больше Чеt.',
    'less': 'Меньше',
    'more': 'Больше',
    'even': 'Чет',
    'odd': 'Нечет',
    'first_five_balls': 'Первых 5',
    'first_ball': 'Первый Шар',
    'last_ball': 'Последний Шар',
    'top_color': 'Самый Частый Цвет',
    'red': 'Красный',
    'green': 'Зеленый',
    'blue': 'Голубой',
    'purple': 'Сиреневый',
    'brown': 'Коричневый',
    'yellow': 'Желтый',
    'orange': 'Оранжевый',
    'black': 'Черный',
    'silver': 'Серебряный',
    'the_most_common_numbers': 'Самое частое число',
    'the_rarest_numbers': 'Самое редкое число',
    'ticket_id': 'Номер Купона',
    'all': 'Все Шары',
    'common_color': 'Самый Частый Цвет',
    'parity': 'Чет/Нечет',
    'round_no': 'Игра Номер',
    'jackpot_code': 'Код Джекпота',
    'purchased_a_ticket': 'Вы успешно оплатили купон!',
    'chose_some_bets': 'Выберите ставку, чтобы оплатить купон!',
    'winner': 'Победитель',
    'w': 'В',
    'l': 'П',
    'FORM': 'Форма',
    'place': 'Место',
    'show': 'Показать',
    'second': 'Второе место',
    'third': 'Третье место',
    'trifecta': 'Трифекта',
    'perfecta': 'Перфекта',
    'double_chance': 'Двойной шанс',
    'low': 'Меньше',
    'high': 'Больше',
    'sum': 'Сумма',
    'jackpot': 'ДЖЕКПОТ',
    'race': 'Гонка',
    'mega_jackpot': 'Мега Джекпот',
    'number_of_goals': 'Количество голов',
    'result': 'Результат',
    'total_goals': 'Всего голов',
    'correct_score': 'Точный результат',
    'ht': 'ТА',
    'ft': 'КО',
    'ht_ft': 'Тайм – конец матча',
    'next': 'Следующий',
    'half_time_full_time': 'Тайм - матч',
    'over_under': 'Голы',
    'full_time_goals_combination': 'Голы по результатам матча',
    'gg_ng': 'ГГ / НГ',
    'double_chance_gg_ng': 'Двойной шанс + ГГ / НГ',
    'home': 'Домашн.',
    'away': 'Гостев.',
    'general_statistics': 'Общая статистика',
    'odd_even': 'Чет./Нечет.',
    'odd_even_home': 'Нечетный/Четный Домашний',
    'odd_even_away': 'Нечетный/Четный Гостевой',
    'home_score': 'Голов дома',
    'away_score': 'Голов в гостях',
    'home_ou': 'Хозяин голов',
    'away_ou': 'Гость голов',
    'uo15_1x2': 'UO15 + 1X2',
    'uo25_1x2': 'UO25 + 1X2',
    'gg_ng_over_under': 'ГГ / НГ ГОЛЫ',
    'first_half': 'Первый Тайм',
    'slip': 'Слип',
    'bet_slip': 'Купон',
    'combinations': 'Комбинации',
    'system': 'Система',
    'total_odd': 'Итоговая квота',
    'total_stake': 'Сумма ставки',
    'potential_maximal_win': 'Потенциальный выигрыш',
    'place_bet': 'Сделать ставку',
    'favorites': 'Фавориты',
    'underdogs': 'Аутсайдеры',
    'please_choose': 'Выберите ставку, чтобы оплатить купон',
    'open': 'Открыто',
    'chose_valid_amount': 'Выберите сумму ставки',
    'no_tickets_for_current_game': 'Для текущей игры ставка невозможна',
    'game': 'Игра',
    'apple_video_no_support': 'Ваше apple устройство не поддерживает стрим. Установите ne версию  iOS10+ для просмотра видео.',
    'color': 'Цвет',
    'error_purchasing_ticket': 'Ошибка при оплате купона',
    'choose_1_2_4_common': 'Выберите один, два или четыре самых распространенных цвета',
    'choose_1_2_4_first': 'Выберите один, два или четыре цвета для первого шара',
    'choose_1_2_4_last': 'Выберите один, два или четыре цвета для последнего шара',
    'confirm_buying': 'Подтвердить',
    'cancel_buying': 'Отказаться',
    'buying_title': 'Вы уверены, что хотите сделать ставку?',
    'please_wait': 'Пожалуйста, подождите..',
    'tutorial_close': 'Закрыть',
    'tutorial_next': 'Следующий',
    'tutorial_back': 'Назад',
    'tutorial_1': 'Краткая инструкция объясняет, как сделать ставку в игре  "Lucky Balls"',
    'tutorial_2': 'Здесь выбираются числа. Выберите от 6 до 10 чисел',
    'tutorial_3': 'Ставки на внешние роли (чет/нечет, частый цвет и т.д) выберите щелчком на кнопки и/или цвета внешних ролей.',
    'tutorial_4': 'Выберите размер ставки: минимальный, максимальный, три существующие опции или внесите сами.',
    'tutorial_5': 'Выберите число раундов.',
    'tutorial_6': 'Щелчком на "Оплатить купон" ваша ставка будет внесена в систему',
    'tutorial_7': 'В этой части экрана можете следить за статусом вашего купона в течении раунда. Выброгенные числа и выигрышные внешние ставки обозначены другим цветом. Заголовок выигрышных купонов обощначен зеленым цветом.',
    'tutorial_8': 'Выброс шаров можете наблюдать в этой части экрана, как будто вы находитесь в букмекерской конторе.',
    'tutorial_9': 'Разные статистики помогут вам сделать ставку на вашу выигрышную комбинацию.',
    'help': 'Помощь',
    'tickets-vfl': 'Купон/Статистика.',
    'results': 'Результаты',
    'for_draw': 'Раунд',
    'draw': 'Ничья',
    'd': 'Н',
    'results_lower': 'Результаты',
    'round_completed': 'Раунд окончен',
    'first_5_no_award': 'Первых пять шаров',
    'last_bets': 'Последние ставки',
    'color_betting': 'Ставка на цвет',
    'preballs_sum': 'Первых 5',
    'bonus_numbers': 'Бонус числа',
    'current_round': 'Текущий раунд',
    'rounds_total': 'Всего раундов',
    'value': 'Value',
    'quick_lucky_ball': 'Quick Lucky Ball',
    'Login': 'Авторизоваться',
    'Logout': 'Выйти',
    'login_credentials': 'Учетные данные',
    'Username': 'имя пользователя',
    'Password': 'пароль',
    'request_payout': 'Запрос выплат',
    'payout_pin': 'PIN-код выплаты',
    'Ok': 'Ok',
    'auth_failed': 'Ошибка: аутентификация не удалась',
    'enter_alias': 'Введите псевдоним',
    'Submit': 'представить',
    'Chat': 'чат',
    'win_multiplier': 'ВЫИГРАЙ МУЛЬТИПЛЕЕР',
    'win_amount': 'ВЫИГРАТЬ СУММУ',
    'first_color': 'ПЕРВЫЙ ЦВЕТ',
    'sure2share': 'Вы уверены, что хотите поделиться?',
    'Share': 'доля',
    'chat_message': 'Сообщение чата',
    'yes': 'Да',
    'no': 'Нет',
    'welcome': 'Желанный',
    'credit_balance': 'Остаток кредита : ',
    'last_color': 'Последний цвет',
    'last_ball_parity': 'Последний Шар Чет/Нечет',
    'ticket_amount_less': 'Сумма купонa не может быть меньше ',
    'ticket_amount_more': 'Сумма купонa не может быть больше чем '
};

langArr["uk"] = {
    'odds': 'Квотування',
    "popular": "ПОПУЛЯРНИЙ",
    "standings": "Турнірна таблиця",
    "final_score": "ФІНАЛЬНИЙ РЕЗУЛЬТАТ",
    "home_goals": "ГОЛ ДОМАШНЯ КОМАНДА",
    "away_goals": "ГОЛ ГОСТЬОВА КОМАНДА",
    "score": "Заб'ють",
    "last_results": "Останні результати",
    "live_score": "Live Score",
    "teams": "КОМАНДИ",
    "team": "КОМАНДА",
    "pts": "Очк",
    "pos": "ПОЗ",
    "please_login": "Будь ласка, увійдіть",
    "minimum_stake_is": "Максимальна ставка",
    "maximum_stake_is": "Мінімальна ставка",
    "you_dont_have_enough_deposit": "У вас недостатньо депозиту",
    "unknown_session_id": "Unknown SessionID",
    "betting": "Зробити ставку",
    "statistics": "Статистика",
    "tickets": "Купони",
    "amount": "Сума",
    "no_of_rounds": "Кіль. Кіл",
    "repeat_last": "Повторити Останнє",
    "random_six": "Випадкові Шість",
    "random": "Випадковий",
    "random_one": "Випадковий",
    "all_colors": "Усі Кольори",
    "hot_six": "Hot Six",
    "cold_six": "Cold Six",
    "buy_ticket": "Оплатити Купон",
    "chosen_ticket_combination": "Обрана Комбінація",
    "all_of_the_balls": "Усі Кулі",
    "more_odd": "Більше Неп.",
    "more_even": "Більше Паr.",
    "less": "Менше",
    "more": "Більше",
    "even": "Пар",
    "odd": "Неп.",
    "first_five_balls": "Перших 5",
    "first_ball": "Перша Куля",
    "last_ball": "Остання Куля",
    "top_color": "Найчастіший Колір",
    "red": "Червоний",
    "green": "Зелений",
    "blue": "Блакитний",
    "purple": "Бузковий",
    "brown": "Коричневий",
    "yellow": "Жовтий",
    "orange": "Помаранчевий",
    "black": "Чорний",
    "silver": "Срібний",
    "the_most_common_numbers": "Найчастіше число",
    "the_rarest_numbers": "Найрідше число",
    "ticket_id": "Номер Купона",
    "all": "Усі Кулі",
    "common_color": "Найчастіший Колір",
    "parity": "Пар/Непар",
    "round_no": "Гра Номер",
    "jackpot_code": "Код Джекпота",
    "purchased_a_ticket": "Ви успішно оплатили купон!",
    "chose_some_bets": "Оберіть ставку, щоб оплатити купон!",
    "winner": "Переможець",
    "w": "В",
    "l": "П",
    "FORM": "Форма",
    "place": "Місце",
    "show": "Показати",
    "second": "Друге місце",
    "third": "Третє місце",
    "trifecta": "Трифекта",
    "perfecta": "Перфекта",
    "double_chance": "Подвійний шанс",
    "low": "Менше",
    "high": "Більше",
    "sum": "Сума",
    "jackpot": "ДЖЕКПОТ",
    "race": "Перегони",
    "mega_jackpot": "Мега Джекпот",
    "number_of_goals": "Кiлькiсть голiв",
    "result": "Результат",
    "total_goals": "Всього голів",
    "correct_score": "Точний рахунок",
    "ht": "Тайм ",
    "ft": "Матч ",
    "ht_ft": "Тайм - кінець матчу",
    "next": "Наступний",
    "half_time_full_time": "Тайм - матч",
    "over_under": "Голи",
    "full_time_goals_combination": "Голи за результатами матчу",
    "gg_ng": "ГГ / НГ",
    "double_chance_gg_ng": "Подвійний шанс + ГГ / НГ",
    "home": "Домашн.",
    "away": "Гостьов.",
    "general_statistics": "Загальна статистика",
    "odd_even": "Пар./Неп.",
    "odd_even_home": "Непарний/Парний Домашній",
    "odd_even_away": "Непарний/Парний Гостьовий",
    "home_score": "Голів вдома",
    "away_score": "Голів у гостях",
    "home_ou": "Гоподар голів",
    "away_ou": "Гість голів",
    "uo15_1x2": "UO15 + 1X2",
    "uo25_1x2": "UO25 + 1X2",
    "gg_ng_over_under": "ГГ / НГ ГОЛИ",
    "first_half": "Перший Тайм",
    "slip": "Сліп",
    "bet_slip": "Купон",
    "combinations": "Комбінації",
    "system": "Система",
    "total_odd": "Загальнийй пар  непар",
    "total_stake": "Cума ставки",
    "potential_maximal_win": "Потенційний виграш",
    "place_bet": "Зробити ставку",
    "favorites": "Фаворити",
    "underdogs": "Аутсайдери",
    "please_choose": "Оберіть ставку, щоб оплатити купон",
    "open": "Відкрито",
    "chose_valid_amount": "Оберіть суму ставки",
    "no_tickets_for_current_game": "Для поточної гри ставка неможлива",
    "game": "Гра",
    "apple_video_no_support": "Ваш apple пристрій не підтримує стрім. Встановіть нову версію iOS10 + для перегляду відео.",
    "color": "Колір",
    "error_purchasing_ticket": "Помилка при оплаті купона",
    "choose_1_2_4_common": "Виберіть один, два або чотири найпоширеніших кольори",
    "choose_1_2_4_first": "Виберіть один, два або чотири кольори для першої кулі",
    "choose_1_2_4_last": "Виберіть один, два або чотири кольори для останньої кулі",
    "confirm_buying": "Підтвердити",
    "cancel_buying": "Відмовитися",
    "buying_title": "Ви впевнені, що хочете зробити ставку?",
    "please_wait": "Будь ласка зачекайте..",
    "tutorial_close": "Закрити",
    "tutorial_next": "Наступний",
    "tutorial_back": "Назад",
    "tutorial_1": "Коротка інструкція пояснює, як зробити ставку в грі ",
    "tutorial_2": "Тут вибираються числа. Виберіть від 6 до 10 чисел",
    "tutorial_3": "Ставки на зовнішні ролі (пар / непар, частий колір і т.д) виберіть натисканням на кнопки і / або кольори зовнішніх ролей.",
    "tutorial_4": "Оберіть розмір ставки",
    "tutorial_5": "Оберіть кількість раундів.",
    "tutorial_6": "Натисканням на 'Оплатити купон' ваша ставка буде внесена у систему",
    "tutorial_7": "У цій частині екрана ви можете відстежувати свої квитки під час раунду. Зіграні номери та виграшні ставки будуть позначені на квитку різними кольорами. Заголовок виграшних квитків буде позначений зеленим кольором.",
    "tutorial_8": "Викид куль можете спостерігати в цій частині екрану, як ніби ви знаходитесь в букмекерській конторі.",
    "tutorial_9": "Різні статистики допоможуть вам зробити ставку на вашу виграшну комбінацію.",
    "help": "Допомога",
    "tickets-vfl": "Купон/Статистика.",
    "results": "Результати",
    "for_draw": "Раунд",
    "draw": "Нічия",
    "d": "н",
    "results_lower": "Результати",
    "round_completed": "Раунд закінчено",
    "first_5_no_award": "Перших п'ять куль",
    "last_bets": "Останні ставки",
    "color_betting": "Ставка на колір",
    "preballs_sum": "Перших 5",
    "bonus_numbers": "Бонус числа",
    "current_round": "Поточний раунд",
    "rounds_total": "Загально раундів",
    'Login': 'Вхід',
    'Logout': 'Вийти',
    'login_credentials': 'Вхідні дані',
    'Username': "Ім'я користувача",
    'Password': 'Пароль',
    'request_payout': 'Попросити виплату',
    'payout_pin': 'PIN-код для виплат',
    'Ok': 'Ok',
    'auth_failed': 'Помилка. Помилка автентифікації',
    'enter_alias': 'Введіть псевдонім',
    'Submit': 'Надіслати',
    'Chat': 'Чат',
    'win_multiplier': 'ВИМОГО МНОГОПІЛЬНИКА',
    'win_amount': 'ВИМОГА СУМКА',
    'first_color': 'ПЕРШИЙ КОЛІР',
    'sure2share': 'Ви впевнені, що хочете поділитися?',
    'Share': 'Поділитися',
    'chat_message': 'Повідомлення чату',
    'yes': 'Так',
    'no': 'Немає',
    'welcome': 'Ласкаво просимо',
    'credit_balance': 'Кредитний баланс: ',
    'last_color': 'Останній колір',
    'last_ball_parity': 'Остання Куля Пар/Непарний',
    'ticket_amount_less': 'Сума kупона не може бути меншою за ',
    'ticket_amount_more': 'Сума kупона не може перевищувати більше '
};

langArr["bg"] = {
    'odds': 'Квоти',
    "popular": "Популярни",
    "standings": "Класиране",
    "final_score": "Краен Резултат",
    "home_goals": "Голове Домакин",
    "away_goals": "Голове Гост",
    "score": "Резултат",
    "last_results": "Последни резултати",
    "live_score": "Резултати на живо",
    "teams": "Отбори",
    "team": "Отбор",
    "pts": "Точки",
    "pos": "Място",
    "please_login": "Моля влезте",
    "minimum_stake_is": "Минималният залог е",
    "maximum_stake_is": "Максималният залог е",
    "you_dont_have_enough_deposit": "Недостатъчен депозит",
    "unknown_session_id": "Неизвестна сесия",
    "please_login": "Моля влезте, за да заложите",
    "betting": "Залагане",
    "statistics": "Статистика",
    "tickets": "Талони",
    "amount": "Кол.",
    "no_of_rounds": "Номер кръг",
    "repeat_last": "Повтори последното",
    "random_six": "Случайни 6",
    "random": "Случайни",
    "random_one": "Случаен",
    "all_colors": "Всички цветове",
    "hot_six": "Горещи шест",
    "cold_six": "Студени шест",
    "buy_ticket": "Купи билет",
    "chosen_ticket_combination": "Комбинация избрани талони",
    "all_of_the_balls": "Всички топки",
    "more_odd": "Пов. нечет.",
    "more_even": "Повече четно",
    "less": "По-мал.",
    "more": "Повече",
    "even": "Чет.",
    "odd": "Неч.",
    "first_five_balls": "Първи 5 топки",
    "first_ball": "Първа топка",
    "last_ball": "Последна топка",
    "top_color": "Топ Цвят",
    "red": "Червено",
    "green": "Черно",
    "blue": "Синьо",
    "purple": "Лилаво",
    "brown": "Кафяво",
    "yellow": "Жълто",
    "orange": "Оранжево",
    "black": "Черно",
    "silver": "Сребърен",
    "the_most_common_numbers": "Най- често срещани числа",
    "the_rarest_numbers": "Най- редки числа",
    "ticket_id": "ID на талона",
    "all": "Всички",
    "common_color": "Общ цвят",
    "parity": "Равенство",
    "round_no": "Мач номер",
    "jackpot_code": "Код на джакпота",
    "purchased_a_ticket": "Вие успешно купихте талон",
    "chose_some_bets": "Моля изберете залог, за да купите талон",
    "winner": "Победител",
    "w": "П",
    "l": "З",
    "FORM": "Форма",
    "place": "Място",
    "show": "Показва",
    "second": "Втори",
    "third": "Трети",
    "trifecta": "Трифекта",
    "perfecta": "Перфекта",
    "double_chance": "Двоен шанс",
    "low": "Ниско",
    "high": "Високо",
    "sum": "Сума",
    "jackpot": "Джакпот",
    "race": "Състезание",
    "mega_jackpot": "Мега джакпот",
    "number_of_goals": "Брой голове",
    "result": "Резултат",
    "total_goals": "Общо голове",
    "correct_score": "Точен резултат",
    "ht": "ПП",
    "ft": "КР",
    "ht_ft": "ПП/КР",
    "next": "Следващ",
    "half_time_full_time": "Първо полувреме- краен резултат",
    "over_under": "Над/Под",
    "full_time_goals_combination": "Краен резултат/ Голове",
    "gg_ng": "ГГ/НГ",
    "double_chance_gg_ng": "Двоен шанс + ГГ/НГ",
    "home": "Домакин",
    "away": "Гост",
    "general_statistics": "Генерална статистика",
    "odd_even": "Чет/Нечеt",
    "odd_even_home": "Четно/ Нечетно домакин",
    "odd_even_away": "Четно/Нечетно гост",
    "home_score": "Резултат домакин",
    "away_score": "Резултат гост",
    "home_ou": "Домакин Над/Под",
    "away_ou": "Гост Над/Под",
    "uo15_1x2": "Над/Под 1.5 + 1Х2",
    "uo25_1x2": "Над/Под 2.5 + 1Х2",
    "gg_ng_over_under": "ГГ/НГ Над/Под",
    "first_half": "Първо полувреме",
    "slip": "Слип",
    "bet_slip": "Фиш",
    "combinations": "Комбинации",
    "system": "Система",
    "total_odd": "Общ коефициент",
    "total_stake": "Общ залог",
    "potential_maximal_win": "Максимална потенциална печалба",
    "place_bet": "Постави залог",
    "favorites": "Фаворити",
    "underdogs": "Аутсайдери",
    "please_choose": "Моля първо изберете залог",
    "open": "Оупън",
    "chose_valid_amount": "Изберете валидна сума на залог",
    "no_tickets_for_current_game": "Няма билети за тази игра",
    "game": "Игра",
    "apple_video_no_support": "Вашето Епъл устройство не поддържа видео стрийм",
    "color": "Цвят",
    "error_purchasing_ticket": "Грешка при купуването на талони",
    "choose_1_2_4_common": "Моля изберете 1,2 или 4 цвята за най- честия цвят",
    "choose_1_2_4_first": "Моля изберете 1,2 или 4 цвята за първата топка",
    "choose_1_2_4_last": "Моля изберете 1,2 или 4 цвята за последната топка",
    "confirm_buying": "ОК",
    "cancel_buying": "Откажи",
    "buying_title": "Сигурни ли сте, че искате да купите билета",
    "please_wait": "Моля изчакайте...",
    "tutorial_close": "Затвори",
    "tutorial_next": "Следващ",
    "tutorial_back": "Назад",
    "tutorial_1": "Този пример ще ви покаже как да направите залог на ",
    "tutorial_2": "Тук можете да изберете вашите числа. Изберете от 6 до 10 числа",
    "tutorial_3": "Може да изберете залози като четно/нечетно, топ цвят и тн. натискайки на бутони и/или цветове",
    "tutorial_4": "Изберете сума на залога",
    "tutorial_5": "Изберете брой на игровите рундове",
    "tutorial_6": "Избирайки 'Купи талон' вашият залог ще бъде приет",
    "tutorial_7": "В тази част на екрана може да следите талоните си за кръга. Изтеглените числа и печелившите залози ще се маркират с различни цветове. Печелившите ще се маркират със зелено. ",
    "tutorial_8": "Тук можете да гледате тегленето на топките.",
    "tutorial_9": "Различни статистики могат да ти помогнат да направиш печеливша комбинация. ",
    "help": "Помощ",
    "tickets-vfl": "Билети/Стат.",
    "results": "Резултати",
    "for_draw": "За равен",
    "draw": "Равен",
    "d": "Д",
    "results_lower": "Резултати",
    "round_completed": "Завършени рундове",
    "first_5_no_award": "Първи 5 топки без награда",
    "last_bets": "Последни залози моля",
    "color_betting": "Залагане на цветове",
    "preballs_sum": "Първи 5",
    "bonus_numbers": "Бонус числа",
    "current_round": "Рунд в момента",
    "rounds_total": "Общо рундове",
    'Login': 'Влизам',
    'Logout': 'Изход',
    'login_credentials': 'Данни за вход',
    'Username': 'Потребител',
    'Password': 'Парола',
    'request_payout': 'Поискайте изплащане',
    'payout_pin': 'ПИН код за изплащане',
    'Ok': 'Ok',
    'auth_failed': 'Грешка: Удостоверяването не бе успешно',
    'enter_alias': 'Въведете псевдоним',
    'Submit': 'Изпращане',
    'Chat': 'Чат',
    'win_multiplier': 'ПЕЧЕЛЕТЕ МНОГОПОЛНИТЕЛ',
    'win_amount': 'ПЕЧЕЛЕТЕ СУМАТА',
    'first_color': 'ПЪРВИ ЦВЯТ',
    'sure2share': 'Наистина ли искате да споделите?',
    'Share': 'Дял',
    'chat_message': 'Съобщение в чата',
    'yes': 'Да',
    'no': 'Не',
    'welcome': 'Добре дошли',
    'credit_balance': 'Кредитен баланс : ',
    'last_color': 'Последен цвят',
    'last_ball_parity': 'Последна топка Четно/Нечетно',
    'ticket_amount_less': 'Сумата на талони не може да бъде по-голяма от ',
    'ticket_amount_more': 'Сумата на талони не може да бъде по-малка от '
};

langArr['pt'] = {
    'odds': 'Cotas',
    'popular': 'popular',
    'standings': 'colocação',
    'final_score': 'Pontuação final',
    'home_goals': 'Gols marcados em casa',
    'away_goals': 'Gols marcados fora',
    'score': 'Ponto',
    'last_results': 'últimos resultados',
    'live_score': 'Resultados ao vivo',
    'teams': 'Equipes',
    'team': 'Time',
    'pts': 'PTS',
    'pos': 'POS',
    'please_login': 'Por favor_ faça o seu login',
    'minimum_stake_is': 'A aposta mínima é',
    'maximum_stake_is': 'A aposta máxíma é',
    'you_dont_have_enough_deposit': 'Você não tem depósito suficiente',
    'unknown_session_id': 'O ID de sessão é desconhecido',
    'please_login': 'Faça o login para fazer uma aposta!',
    'betting': 'Apostar',
    'statistics': 'Estatisticas',
    'tickets': 'Bilhetes',
    'amount': 'Montante',
    'no_of_rounds': 'No. de rodadas',
    'repeat_last': 'Repita o último',
    'random_six': 'Seis aleatórios',
    'random': 'Aleatório',
    'random_one': 'Aleatório',
    'all_colors': 'Todas as cores',
    'hot_six': 'Os seis mais frequentes',
    'cold_six': 'Os seis mais raros',
    'buy_ticket': 'Compre o bilhete',
    'chosen_ticket_combination': 'Combinação de bilhetes selecionada',
    'all_of_the_balls': 'Todas as bolas',
    'more_odd': 'Mais ímpares',
    'more_even': 'Mais pares',
    'less': 'Menos',
    'more': 'Mais',
    'even': 'Par',
    'odd': 'ímpar',
    'first_five_balls': 'As primeiras 5 bolas',
    'first_ball': 'Primeiras bola',
    'last_ball': 'Última bola',
    'top_color': 'Cor mais frequente',
    'red': 'Vermelho',
    'green': 'Verde',
    'blue': 'Azul',
    'purple': 'Roxo',
    'brown': 'Marrom',
    'yellow': 'Amarelo',
    'orange': 'Cor-de-Laranja',
    'black': 'Preto',
    'silver': 'Cor-de-Prata',
    'the_most_common_numbers': 'Números mais frequentes',
    'the_rarest_numbers': 'Os números mais raros',
    'ticket_id': 'ID do bilhete',
    'all': 'Todos',
    'common_color': 'Cor de costume',
    'parity': 'Paridade',
    'round_no': 'Rodada no.',
    'jackpot_code': 'O código de jackpot',
    'purchased_a_ticket': 'Você comprou o bilhete com sucesso',
    'chose_some_bets': 'Escolha algumas apostas para comprar os bilhetes',
    'winner': 'Ganhador',
    'w': 'W',
    'l': 'L',
    'FORM': 'FORMA',
    'place': 'Localidade',
    'show': 'Exibição',
    'second': 'Segundo',
    'third': 'Terceiro',
    'trifecta': 'Trifecta',
    'perfecta': 'Perfeta',
    'double_chance': 'Chance dupla',
    'low': 'Baixo',
    'high': 'Alto',
    'sum': 'Soma',
    'jackpot': 'jackpot',
    'race': 'CORRIDA',
    'mega_jackpot': 'Jackpot mega',
    'number_of_goals': 'Número de gols',
    'result': 'RESULTADO',
    'total_goals': 'TOTAL DE GOLS',
    'correct_score': 'RESULTADO EXATO',
    'ht': 'HT',
    'ft': 'FT',
    'ht_ft': 'HT/FT',
    'next': 'PRÓXIMO',
    'half_time_full_time': 'Meio tempo/ Fim do jogo',
    'over_under': 'MAIS / MENOS',
    'full_time_goals_combination': 'MEIO TEMPO/COMBINAÇÃO DE GOLS',
    'gg_ng': 'GG / NG',
    'double_chance_gg_ng': 'DUPLA CHANCE + GG/NG',
    'home': 'EM CASA',
    'away': 'FORA DE CASA',
    'general_statistics': 'Estatística geraL',
    'odd_even': 'ÍMPAR / PAR',
    'odd_even_home': 'ÍMPAR / PAR EM CASA',
    'odd_even_away': 'ÍMPAR / PAR FORA DE CASA',
    'home_score': 'RESULTADO EM CASA',
    'away_score': 'RESULTADO FORA DE CASA',
    'home_ou': 'OU EM CASA',
    'away_ou': 'OU FORA DE CASA',
    'uo15_1x2': 'UO15 + 1X2',
    'uo25_1x2': 'UO25 + 1X2',
    'gg_ng_over_under': 'GG / NG MAIS MENOS',
    'first_half': 'PRIMEIRO MEIO TEMPO',
    'slip': 'Boletim',
    'bet_slip': 'Boletim de apostas',
    'combinations': 'Combinações',
    'system': 'Sistema',
    'total_odd': 'Total de pares',
    'total_stake': 'Participação total',
    'potential_maximal_win': 'Ganho máximo potencial',
    'place_bet': 'Faça as apostas',
    'favorites': 'Favoritos',
    'underdogs': 'Azarões',
    'please_choose': 'Por favor escolha algumas apostas primeiro',
    'open': 'ABRIR',
    'chose_valid_amount': 'Selecione um montante de aposta válido',
    'no_tickets_for_current_game': 'Não tem bilhetes para o jogo atual',
    'game': 'Jogo',
    'apple_video_no_support': 'Seu dispositivo Apple não suporta a transmissão de gravação de vídeo, atualize-o para o iOS 10+ para assistir a vídeos de corrida.',
    'color': 'Cor',
    'error_purchasing_ticket': 'Erro na compra do bilhete',
    'choose_1_2_4_common': 'Escolha 1,2 ou 4 cores para as cores mais frequentes',
    'choose_1_2_4_first': 'Escolha 1,2 ou 4 cores para a primeira bola',
    'choose_1_2_4_last': 'Escolha 1,2 ou 4 cores para a última bola',
    'confirm_buying': 'Confirmar a compra',
    'cancel_buying': 'Cancelar a compra',
    'buying_title': 'Você tem a certeza que quer comprar um bilhete?',
    'please_wait': 'Por favor, espere',
    'tutorial_close': 'FECHAR',
    'tutorial_next': 'PRÓXIMO',
    'tutorial_back': 'VOLTAR',
    'tutorial_1': 'Este guia rápido explicará como fazer uma aposta em "Lucky Balls" ',
    'tutorial_2': 'Aqui você pode escolher seus números. Escolha 6 a 10 números. ',
    'tutorial_3': 'Você pode escolher apostas como par / ímpar, a cor mais frequente, etc. clicando nas teclas e / ou cores de apostas.',
    'tutorial_4': 'Escolha o valor da aposta: mínimo, máximo três valores exibidos ou digite um valor personalizado.',
    'tutorial_5': 'Selecione o número de rodadas do jogo.',
    'tutorial_6': 'Ao clicar em "Comprar o Bilhete", sua aposta será aceite.',
    'tutorial_7': 'Nesta parte da tela, você pode seguir os bilhetes durante a rodada. Os números sorteados e as apostas vencedoras serão marcados no bilhete em cores diferentes. O título dos bilhetes vencedores será marcado em verde. ',
    'tutorial_8': 'Nesta parte da tela você pode assistir as bolas sendo sorteadas.',
    'tutorial_9': 'Várias estatísticas podem ajudá-lo a fazer sua combinação vencedora.',
    'help': 'Ajuda',
    'tickets-vfl': 'Bilhetes / Estatística',
    'results': 'RESULTADOS',
    'for_draw': 'Para sortear',
    'draw': 'Sorteio',
    'd': 'D',
    'results_lower': 'Resultados',
    'round_completed': 'Rodada finalizada',
    'first_5_no_award': 'AS PRIMEIRAS 5 BOLAS SEM PRÊMIO',
    'last_bets': 'Últimas apostas!',
    'color_betting': 'Aposta em cores',
    'preballs_sum': 'Soma dos primeiros cinco números',
    'bonus_numbers': 'Números de bônus',
    'current_round': 'Rodada corrente',
    'rounds_total': 'rodadas totais',
    'value': 'Valor',
    'quick_lucky_ball': 'Bola de sorte rápida ',
    'Login': 'Fazer o login',
    'Logout': 'Deslogar',
    'login_credentials': 'Dados de acesso para o login',
    'Username': 'Nome do usuário',
    'Password': 'Senha',
    'request_payout': 'Solicitar o pagamento',
    'payout_pin': 'PIN para o pagamento',
    'Ok': 'Está bem',
    'auth_failed': 'Erro: Falha na autenticação',
    'enter_alias': 'Digite uma alcunha ',
    'Submit': 'Encaminhar',
    'Chat': 'Bate-papo',
    'win_multiplier': 'multiplicador de ganho',
    'win_amount': 'QUANTIA DE GANHO',
    'first_color': 'PRIMEIRA COR',
    'sure2share': 'Tem a certeza que deseja compartilhar?',
    'Share': 'Compartilhar',
    'chat_message': 'Mensagens de bate-papo',
    'yes': 'Sim',
    'no': 'Não',
    'welcome': 'Bem vindo',
    'credit_balance': 'Saldo de crédito:',
    'last_color': 'Última cor',
    'last_ball_parity': 'Paridade da  Última Bola',
    'ticket_amount_less': 'O valor do bilhete não pode ser inferior a',
    'ticket_amount_more': 'O valor do bilhete não pode ser superior a',
    'betting_info': 'Disponível das 7 às 23 h'
}

langArr['tr'] = {
    'odds': 'Kotalar',
    'popular': 'Popüler',
    'standings': 'Puan durumu',
    'final_score': 'Son Skor',
    'home_goals': 'Ev Sahibi Golleri',
    'away_goals': 'Deplasman Golleri',
    'score': 'Skor',
    'last_results': 'Son Sonuçlar',
    'live_score': 'Canlı Skor',
    'teams': 'Takımlar',
    'team': 'TAKIM',
    'pts': 'PTS',
    'pos': 'POS',
    'please_login': 'Lütfen Giriş Yapın',
    'minimum_stake_is': 'Minimum bahis',
    'maximum_stake_is': 'Maksimum bahis',
    'you_dont_have_enough_deposit': 'Yeterli depozitonuz yok',
    'unknown_session_id': 'Bilinmeyen oturum kimliği',
    'please_login': 'Bahis yapmak için lütfen giriş yapın!',
    'betting': 'Bahis',
    'statistics': 'İstatistikler',
    'tickets': 'Bahis biletleri',
    'amount': 'Miktar',
    'no_of_rounds': 'Tur sayısı',
    'repeat_last': 'Sonuncuyu tekrarla',
    'random_six': 'Rastgele Altı',
    'random': 'Rastgele',
    'random_one': 'Rastgele',
    'all_colors': 'Tüm Renkler',
    'hot_six': 'Hot Six',
    'cold_six': 'Cold Six',
    'buy_ticket': 'Bilet al',
    'chosen_ticket_combination': 'Seçilen Bilet Kombinasyonu',
    'all_of_the_balls': 'Tüm Toplar',
    'more_odd': 'Fazla Tek',
    'more_even': 'Fazla Çift',
    'less': 'Daha az',
    'more': 'D. fazla',
    'even': 'Çift',
    'odd': 'Tek',
    'first_five_balls': 'İlk beş Top',
    'first_ball': 'İlk Top',
    'last_ball': 'Son Top',
    'top_color': 'En iyi Renk',
    'red': 'Kırmızı',
    'green': 'Yeşil',
    'blue': 'Mavi',
    'purple': 'Mor',
    'brown': 'Kahve rengi',
    'yellow': 'Sarı',
    'orange': 'Turuncu',
    'black': 'Siyah',
    'silver': 'Gümüş',
    'the_most_common_numbers': 'En yaygın sayılar',
    'the_rarest_numbers': 'En nadir sayılar',
    'ticket_id': 'Bilet kimliği',
    'all': 'Her şey',
    'common_color': 'Yaygın Renk',
    'parity': 'Eşitlik',
    'round_no': 'Tur sayısı',
    'jackpot_code': 'Jackpot kodu',
    'purchased_a_ticket': 'Bileti başarıyla satın aldınız',
    'chose_some_bets': 'Lütfen bilet satın almak için bazı bahisler seçin',
    'winner': 'Kazanan',
    'w': 'G',
    'l': 'M',
    'FORM': 'OLUŞTURUN',
    'place': 'Yerleştirin',
    'show': 'Gösterin',
    'second': 'İkinci',
    'third': 'Üçüncü',
    'trifecta': 'Trifecta',
    'perfecta': 'Perfecta',
    'double_chance': 'Çifte Şans',
    'low': 'Düşük',
    'high': 'Yüksek',
    'sum': 'Toplam',
    'jackpot': 'JACKPOT',
    'race': 'YARIŞ',
    'mega_jackpot': 'Mega Jackpot',
    'regional_jackpot': 'Bölgesel Jackpot',
    'weldmag_regional_jackpot': 'SUPERBONUS',
    'weldmag_jackpot':'WELDPOT',
    'number_of_goals': 'GOLLER SAYISI',
    'result': 'SONUÇ',
    'total_goals': 'TOPLAM GOLLER',
    'correct_score': 'DOĞRU SKOR',
    'ht': 'İY',
    'ft': 'MS',
    'ht_ft': 'İY/MS',
    'next': 'İLERİ',
    'half_time_full_time': 'İLK YARI SONUCU / MAÇ SONUCU',
    'over_under': 'ÜST ALT',
    'full_time_goals_combination': 'MAÇ SONUCU / GOLLER KOMBİNASYONU',
    'gg_ng': 'GG / GO',
    'double_chance_gg_ng': 'ÇİFTE ŞANS + GG / GO',
    'home': 'EV SAHİBİ',
    'away': 'DEPLASMAN',
    'general_statistics': 'Genel İstatistikler',
    'odd_even': 'TEK/ÇİFT',
    'odd_even_home': 'TEK / ÇİFT (*EV SAHİBİ)',
    'odd_even_away': 'TEK / ÇİFT (*DEPLASMAN)',
    'home_score': 'EV SAHİBİ SKORU',
    'away_score': 'DEPLASMAN SKORU',
    'home_ou': 'EV SAHİBİ ÜST/ALT',
    'away_ou': 'DEPLASMAN ÜST/ALT',
    'uo15_1x2': 'UO15 + 1X2',
    'uo25_1x2': 'UO25 + 1X2',
    'gg_ng_over_under': 'GG / GO ÜST ALT',
    'first_half': 'İLK YARI SONUCU',
    'slip': 'Kupon',
    'bet_slip': 'BAHİS KUPONU',
    'combinations': 'Kombinasyonlar',
    'system': 'Sistem',
    'total_odd': 'Toplam Tek',
    'total_stake': 'Toplam Risk',
    'potential_maximal_win': 'Potansiyel maksimum kazanç',
    'place_bet': 'Bahis oyna',
    'favorites': 'Favoriler',
    'underdogs': 'Averaj takımı',
    'please_choose': 'Lütfen önce bazı bahisleri seçin',
    'open': 'AÇ',
    'chose_valid_amount': 'Lütfen geçerli bahis tutarını seçin',
    'no_tickets_for_current_game': 'Şu anki oyun için biletler yok',
    'game': 'Oyun',
    'apple_video_no_support': 'Apple cihazınız video akışını desteklemiyor, lütfen yarış videolarını izlemek için iOS 10+ sürümüne yükseltin.',
    'color': 'Renk',
    'error_purchasing_ticket': 'Bilet alırken hata oluştu',
    'choose_1_2_4_common': 'Lütfen en yaygın renk için 1,2 veya 4 renk seçin ',
    'choose_1_2_4_first': 'Lütfen ilk top için 1,2 veya 4 renk seçin ',
    'choose_1_2_4_last': 'Lütfen son top için 1,2 veya 4 renk seçin ',
    'confirm_buying': 'OK',
    'cancel_buying': 'İptal edin',
    'buying_title': 'Bilet almak istediğinize emin misiniz?',
    'please_wait': 'Lütfen bekleyin...',
    'tutorial_close': 'KAPATIN',
    'tutorial_next': 'İLERİ',
    'tutorial_back': 'GERİ',
    'tutorial_1': 'Bu hızlı eğitim size "Lucky balls" üzerine nasıl bahis yapacağınızı açıklayacak.',
    'tutorial_2': ' Buradan numaralarınızı seçebilirsiniz. 6 ila 10 numara seçin.',
    'tutorial_3': 'Bir bahsin butonlarına ve/veya renklerine tıklayarak çift/tek, üst renk vb. bahisleri seçebilirsiniz.',
    'tutorial_4': ' Bir bahis miktarını seçin: minimum, maksimum, sunulan üç değer veya özel bir miktar girin.',
    'tutorial_5': ' Birkaç oyun turu seçin.',
    'tutorial_6': "'Bilet satın al'a tıklayarak bahsiniz kabul edilecektir.",
    'tutorial_7': 'Ekranın bu bölümünde tur sırasında biletlerinizi izleyebilirsiniz. Çekilen numaralar ve kazanan bahisler bilete farklı renklerle işaretlenecektir. Kazanan biletlerin başlığı yeşil olarak işaretlenecektir.',
    'tutorial_8': 'Ekranın bu bölümünde top çekilişini izleyebilirsiniz..',
    'tutorial_9': 'Çeşitli istatistikler, kazanma kombinasyonunuzu oluşturmanıza yardımcı olabilir.',
    'help': 'Yardım',
    'tickets-vfl': 'Biletler/İstatistikler',
    'results': 'SONUÇLAR',
    'for_draw': 'Çekiliş İçin',
    'draw': 'Çekiliş',
    'd': 'Ç',
    'results_lower': 'Sonuçlar',
    'round_completed': 'TUR TAMAMLANDI',
    'first_5_no_award': 'ÖDÜLSÜZ İLK 5 TOP',
    'last_bets': 'Son bahisler lütfen!',
    'color_betting': 'Renk Bahis',
    'preballs_sum': 'Ön top toplamı',
    'bonus_numbers': 'Bonus numaraları',
    'current_round': 'Şu anki tur',
    'rounds_total': 'Turlar toplamı',
    'value': 'Değer',
    'quick_lucky_ball': 'Hızlı Lucky Ball',
    'Login': 'Giriş',
    'Logout': 'Çıkış',
    'login_credentials': 'Giriş kimlik',
    'Username': 'Kullanıcı adı',
    'Password': 'Şifre',
    'request_payout': 'Ödeme isteği',
    'payout_pin': 'Ödeme PIN kodu',
    'Ok': 'Ok',
    'auth_failed': 'Hata: Kimlik doğrulama başarısız oldu ',
    'enter_alias': 'Takma adını girin',
    'Submit': 'Gönderin',
    'Chat': 'Sohbet',
    'win_multiplier': 'ÇARPAN KAZANIN',
    'win_amount': 'KAZANMA MİKTARI',
    'first_color': 'İLK RENK',
    'sure2share': 'Paylaşmak istediğinize emin misiniz?',
    'Share': 'Paylaşın',
    'chat_message': 'Sohbet Mesajı',
    'yes': 'Evet',
    'no': 'Hayır',
    'welcome': 'Hoş geldiniz',
    'credit_balance': 'Kredi dengesi : ',
    'last_color': 'Son Renk',
    'last_ball_parity': 'Son Top Eşitliği',
    'ticket_amount_less': 'Bilet miktarı en az ',
    'ticket_amount_more': 'Bilet miktarı en fazla ',
    'betting_info': ' 7 - 23 saat arasında müsait'
}


//////////////////
// WEBPACK FOOTER
// ./src/ui/js/language.js
// module id = 40
// module chunks = 11